/* ===========================GENERAL FUNCTIONS=========================== */

(function ($) {
	$.fn.isInViewport = function (offset) {
		if ($(this).offset()) {
			if (typeof offset === "undefined") {
				offset = 0;
			}
			var elementTop = $(this).offset().top + offset;
			var elementBottom = elementTop + $(this).outerHeight();
			var viewportTop = $(window).scrollTop();
			var viewportBottom = viewportTop + $(window).height();
			return elementBottom > viewportTop && elementTop < viewportBottom;
		}
	};
})(jQuery);

function setVendor(element, value) {
	if (navigator.userAgent.match("Chrome")) {
		element.style.WebkitTransform = value;
	} else if (navigator.userAgent.match("Firefox")) {
		element.style.MozTransform = value;
	} else if (navigator.userAgent.match("MSIE")) {
		element.style.msTransform = value;
	} else if (navigator.userAgent.match("Opera")) {
		element.style.OTransform = value;
	} else {
		element.style.transform = value;
	}
}

function toggleLoadingAnimation(relativeParent, dimmArray, ringcolor) {
	var ring = "";
	if (typeof ringcolor == "undefined") {
		ring = '<img src="/assets/gizzmo/img/icons/green_ring.svg?v=1" class="animation__rotate" />';
	} else {
		ring = '<img src="/assets/gizzmo/img/icons/' + ringcolor + '_ring.svg?v=1" class="animation__rotate" />';
	}

	if (typeof dimmArray == "undefined") {
		dimmArray = [];
	}

	var $context = $("#" + relativeParent);
	if ($.trim($context.html()) == "") {
		return;
	}

	var $animation = $context.find(".animation__rotate");

	if ($animation.length > 0) {
		$animation.remove();

		$context.children().each(function () {
			$(this).removeClass("animation-opacity");
		});

		if (dimmArray.length != 0) {
			dimmArray.forEach(function (id) {
				$("#" + id).removeClass("animation-opacity");
			});
		}
	} else {
		$context.children().each(function () {
			if (!$(this).hasClass("animation-exclude")) {
				$(this).addClass("animation-opacity");
			}
		});
		$context.append($(ring));

		if (dimmArray.length != 0) {
			dimmArray.forEach(function (id) {
				$("#" + id).addClass("animation-opacity");
			});
		}
	}
}

document.addEventListener('DOMContentLoaded', function() {
	var path = window.location.pathname;

	path = path.replace("/app_dev.php", "");

	// Extract the slug using a regular expression
	var slug = path.match(/\/(.+?)-artikel/);
	slug = slug ? slug[1] : null;

	var productId = path.match(/-artikel-(.+)/);
	productId = productId ? productId[1] : null;
	var backInStockModal = $('.back-in-stock-modal');

	if(productId && backInStockModal.length != 0){
		data = {
			productId: productId,
			slug: slug
		}
		
		$.ajax({
			url: window.jstransobj.linkPrefix + "/product/back-in-stock-form",
			method: "POST",
			data: data,
			success: function (data) {
				$('.back-in-stock-modal .modal-content-inner').append(data.html);
			},
			complete: function (data) {
				var form = document.querySelector('.back-in-stock-modal form'); 

				if(form){
					form.addEventListener('submit', function(e) {
						e.preventDefault();

						document.querySelector('#subscribe-to-back-in-stock').style.color = "rgba(255,255,255,.15)";
						toggleLoadingAnimation("subscribe-to-back-in-stock", [], "white");

						var formData = new FormData(form);
						formData.append('productId', productId);
    					formData.append('slug', slug);
						
						$.ajax({
							url: window.jstransobj.linkPrefix + '/product/subscribe-to-back-in-stock-notification',
							method: "POST",
							data: formData,
							processData: false,
							contentType: false,
							success: function (response) {
								openSuccessModal();
								closeModal();
							},
						});
					});
				}
			}
		});
	}
});

$(function () {
	$("#selectbox").on("change", function () {
		$(this).removeClass("select--ten-plus");
		$(".add-to-cart-wrapper").removeClass("add-to-cart-wrapper--ten-plus");
		if (parseInt($(this).val()) >= 10) {
			$(this).addClass("select--ten-plus");
			$(".add-to-cart-wrapper").addClass("add-to-cart-wrapper--ten-plus");
		}
	});
});

/* CART */

// jQuery(document).ready(function($){
this.MobileCart = function () {
	var cachedData = null;

	$(".cd-cart .body").stop();

	var myUrlParams = new URL(window.location.href).searchParams;
	if(myUrlParams.get('clickid')){
		document.cookie = "rtkcid="+ myUrlParams.get('clickid');
	}
	if(myUrlParams.get('rtkcid')){
		document.cookie = "rtkcid="+ myUrlParams.get('rtkcid');
	}

	var cartWrapper = $(".cd-cart-container");
	var productId = 0;
	var touchStartOrClickEvent = "click";

	if (cartWrapper.length > 0) {
		var documentBodyScrollTop = 0;
		var cdCartContainer = $(".cd-cart-container");
		var cdCart = cartWrapper.find(".cd-cart");
		var emptyCartOverlay = cartWrapper.find(".empty-cart-overlay");
		var cartBody = cartWrapper.find(".body");
		var cartList = cartBody.find("#cart-list");
		var cartTotal = cartWrapper.find(".checkout").find("span");
		var goToCheckoutButton = $("#goToCheckout");
		var cartTriggerMobile = $("#mobile-cart-trigger");
		var closeCartHeaderMobile = $("#close-cart-header .back");
		var addToCartBtn = $("#add-to-cart");
		var multipleAddToCart = $('[data-add-to-cart]');
		var multipleSelectBox = $('[data-quantity-select]');
		var stickyAddToCartBtn = $("#sticky-add-to-cart-btn");
		var addToCartBtnBottom = $("#add-to-cart-bottom");
		var sumAllWrapper = $(".sum-all-wrapper");
		var crossSellOfferWrapper = $("#crossSellOfferWrapper");
		var crossSellWrapper = $("#crossSellOfferWrapper");
		var addBundleBtn = $("[data-add-bundle]");
		var addCustomQuantityOffer = $('[data-add-custom-quantity-offer]')
		var headerQuantityOptions = $(".header-quantity-selector-wrapper");		
		var ajaxQueue = [];
		var $removeRequest;
		var $addToCartRequest;
		var cartCrossRequest;
		var runCouponRegisterEvents = true;
		var hasRebornProduct = false;

		if (getCookie("cart") != "") {
			getFromCart(false);
			loadCartCrossSell();
		}

		headerQuantityOptions.find(".qd").on("click", function (event) {
			if (checkIfOptionIsSelected() == false) {
				if (typeof closeHeaderQuantitySelector == "function") {
					closeHeaderQuantitySelector();
				}
				return;
			}
			if ($("#headerAddToCartBtn").attr("working") == "yes") {
				return;
			}
			$("#headerAddToCartBtn").attr("working", "yes");
			toggleLoadingAnimation("headerQuantitySelector", []);

			var productId = addToCartBtn.attr("data-id");
			if ($(".poptions").length > 0) {
				productId = $(".poptions").find(":selected").eq(0).data("productId");
			}

			addProduct(productId, parseInt($(this).data("qty")));
		});

		$("#shoppingCart").on("click", function (event) {
			if ($(event.target).attr("id") == "shoppingCart") {
				cartTriggerMobile.trigger(touchStartOrClickEvent);
			}
		});

		$("body").on(touchStartOrClickEvent, "[data-add-bundle]", function (event) {
			event.preventDefault();
			event.stopPropagation();
			addBundleBtn = $("[data-add-bundle]");

			if (addBundleBtn.parent().hasClass("loading")) {
				return;
			}
			addBundleBtn.parent().addClass("loading");
			__enableLoader(".superbundle-atc-wrapper");

			addBundleToCart(
				{
					tag: $(this).data("tag"),
					product_id: $(this).data("productId"),
					bundleProducts: $(this).data("bundleIds"),
				},
				function () {
					uncheckIcsIfBundleHasIt();
				}
			);
		});

		addCustomQuantityOffer.on(touchStartOrClickEvent, function (event) {
			event.preventDefault();
			event.stopPropagation();

			if ($('.select-between-offers').hasClass("loading")) {
				return;
			}

			if($(this).data('addSelected') == "yes") {
				if(isCustomQuantityOptionIsSelected()) {
					$(this).addClass("loading");
					__enableLoader(".quantity-offer-block .add-to-cart");
					
					addSelectedCustomQuantityProduct();
				}
			} else {
				$(this).addClass("loading");
				__enableLoader(".quantity-offer-block .add-to-cart");
				
				addCustomQuantityProduct(
					{
						tag: $(this).data("tag"),
						product_id: $(this).data("productId"),
						quantity: $(this).data("qty"),
					}
				);
			}
		});

		function refreshElements() {
			addBundleBtn = $("[data-add-bundle]");
		}

		function addSelectedCustomQuantityProduct() {
			var $selectedOffer = $('.quantity-offer-block .offer-wrapper.selected');

			if($selectedOffer.length == 0) { return; }
			addCustomQuantityProduct(
				{
					tag: $selectedOffer.data("tag"),
					product_id: $selectedOffer.data("productId"),
					quantity: $selectedOffer.data("qty"),
				}
			);
		}

		function isCustomQuantityOptionIsSelected() {
			if ($('.quantity-offer-block .offer-wrapper.selected').length == 0) {
				alert(window.jstransobj.selectProductOption);
				return false;
			}
	
			return true;
		}

		function addCustomQuantityProduct(options, callback) {
			var data = {};
			var product_id = options.product_id !== undefined ? options.product_id : "";
			var url = jstransobj.linkPrefix + "/cart/customquantityoffer/add/" + product_id;
			var tag = options.tag !== undefined ? options.tag : "";
			var quantity = options.quantity !== undefined ? options.quantity : "";

			data = {
				customQuantityOffer: {
					tag: tag,
					qty: quantity
				},
			};

			$.ajax({
				url: url,
				method: "POST",
				data: data,
				cache: false,
				success: function (data) {
					addCustomer();

					if (typeof callback == "function") {
						callback();
					}

					getFromCart(true);
					
					getAddToCartPushObject(product_id, quantity);
				},
				complete: function () {
					var cartId = getCookie("cart");
					sibPush(cartId);
				},
			});
		}

		function uncheckIcsIfBundleHasIt() {
			refreshElements();

			if (addBundleBtn.length == 0) {
				return;
			}

			var superBundleProducts = addBundleBtn.data("bundleIds").split(",");
			superBundleProducts.forEach(function (superBundleProductId) {
				var $icsProductWrapper = $('.product__crossell[data-product-id="' + superBundleProductId + '"]');
				if ($icsProductWrapper.length) {
					if ($icsProductWrapper.hasClass("checked")) {
						$icsProductWrapper.find(".product__crossell__content").click();
					}
				}
			});
		}

		function addBundleToCart(options, callback) {
			var data = {};
			var product_id = options.product_id !== undefined ? options.product_id : "";
			var url = jstransobj.linkPrefix + "/cart/superbundle/add/" + product_id;
			var tag = options.tag !== undefined ? options.tag : "";
			data = {
				superBundle: {
					tag: tag,
					bundleProducts: options.bundleProducts,
				},
			};

			$.ajax({
				url: url,
				method: "POST",
				data: data,
				cache: false,
				success: function (data) {
					addCustomer();

					if (typeof callback == "function") {
						callback();
					}

					getFromCart(true);

					doSuperbundleAnalyticsPush(options.bundleProducts);
				},
				complete: function () {
					var cartId = getCookie("cart");
					sibPush(cartId);
				},
			});
		}

		function doSuperbundleAnalyticsPush(superbundleProducts) {
			superbundleProducts.split(",").forEach(function (el) {
				getAddToCartPushObject(el, 1);
			});
		}

		//add product to cart
		addToCartBtn.on("click", function (event) {
			event.preventDefault();

			if (checkIfOptionIsSelected() == false) {
				return;
			}

			if ($addToCartRequest != null) {
				return false;
			}

			dataLayer.push(window._getItemOnLoadPushObjectAdd);

			addToCartBtn.css("color", "rgba(255,255,255,.15)");
			toggleLoadingAnimation("add-to-cart", [], "white");
			addToCartBtn.attr("working", "true");

			var productId = addToCartBtn.attr("data-id");
			if ($(".poptions").length > 0) {
				productId = $(".poptions").find(":selected").eq(0).data("productId");
			}

			addProduct(productId, parseInt($("#selectbox").find(":selected").val()));
		});

		multipleAddToCart.on('click', function(event) {
			event.preventDefault();
			var quantity = $(this).data('quantity');
			var productId = $(this).data('productId');

			addProduct(productId, quantity ? quantity : 1);
		});

		multipleSelectBox.on('change', function(event) {
			event.preventDefault();
			$(multipleSelectBox).val($(this).val());
			$(multipleAddToCart).data('quantity', $(this).val());
			$(multipleAddToCart).attr('data-quantity', $(this).val());
		});

		stickyAddToCartBtn.on("click", function (event) {
			event.preventDefault();
			addToCartBtn.trigger("click");

			stickyAddToCartBtn.css("color", "rgba(255,255,255,.15)");
			toggleLoadingAnimation("sticky-add-to-cart-btn", [], "white");
			stickyAddToCartBtn.attr("working", "true");
		});

		addToCartBtnBottom.on("click", function (event) {
			event.preventDefault();
			addToCartBtn.trigger("click");

			addToCartBtnBottom.css("color", "rgba(255,255,255,.15)");
			toggleLoadingAnimation("add-to-cart-bottom", [], "white");
			addToCartBtnBottom.attr("working", "true");
		});

		cartTriggerMobile.on(touchStartOrClickEvent, function (event) {
			event.stopPropagation();
			event.preventDefault();
			toggleCartMobile();
		});

		window.addEventListener("hashchange", function (e) {
			if (cartTriggerMobile.data("visible")) {
				if (e.newURL.length < e.oldURL.length) {
					toggleCartMobile();
				}
			}
		});

		closeCartHeaderMobile.on(touchStartOrClickEvent, function (event) {
			event.stopPropagation();
			event.preventDefault();
			toggleCartMobile();
		});

		cdCartContainer.on("click", ".atc-button", function (e) {
			e.preventDefault();
			e.stopPropagation();

			var atcButtonId = $(this).attr("id");

			stickyAddToCartBtn.css("color", "rgba(255,255,255,.15)");
			toggleLoadingAnimation("sticky-add-to-cart-btn", [], "white");
			stickyAddToCartBtn.attr("working", "true");

			toggleLoadingAnimation(atcButtonId, [], "white");

			if(typeof $(this).data("type") != "undefined") {
				addProduct($(this).parents(".product").data("productId"), 1, $(this).data("type"), function() {
					toggleLoadingAnimation(atcButtonId, [], "white");
				});
			} else {
				addProduct($(this).parents(".product").data("productId"), 1, "cross", function() {
					toggleLoadingAnimation(atcButtonId, [], "white");
				});
			}
			//$(this).text($(this).data('moreText'));
		});

		//delete an item from the cart
		cartList.on("click", ".delete-item", function (event) {
			event.preventDefault();
			var $product = $(this).parents(".product");
			ajaxQueue.push(1);

			addToCartBtn.css("color", "rgba(255,255,255,.15)");
			toggleLoadingAnimation("add-to-cart", [], "white");
			addToCartBtn.attr("working", "true");

			removeProduct($product);
		});

		$("#cart-list").on("change", "select", function () {
			var $product = $(this).parents(".product");
			changeProductQuantity($product.data("cartProductId"), $(this).val());

			$(this).attr("previous-qty", $(this).val());
		});

		$(".poptions").change(function () {
			var selectedIndex = $(this).prop("selectedIndex");
			$(".poptions").prop("selectedIndex", selectedIndex);
			var $option = $(".poptions");

			var optionId = $option.find(":selected").data("optionId");
			var productId = $option.find(":selected").data("productId");

			$("#add-to-cart").attr("data-id", productId);
			$("#add-to-cart-bottom").attr("data-id", productId);

			$("#add-to-cart").addClass("selectbox__addtocart__outOfStock");
			$("#add-to-cart-bottom").addClass("selectbox__addtocart__outOfStock");
			$(".prices").css("opacity", "0.5");
			toggleLoadingAnimation("product__gallery");
			toggleLoadingAnimation("product__gallery__bottom");
			getProducOptiontInformation(optionId, function (product) {
				if (product.update == true) {
					if (window.jstransobj.isFullView) {
						desktopOptionChange(optionId, product, productId);
					} else {
						mobileOptionChange(optionId, product, productId);
					}
				}
			});
		});

		$(".productline-options .possible-options .option").on(touchStartOrClickEvent, function () {
			if ($(this).hasClass("option--out-of-stock")) {
				$(this).siblings(".text__out-of-stock").slideDown();
				return;
			}
			var optionId = $(this).data("optionId");
			var productId = $(this).data("productId");

			addToCartBtn.attr('data-id', productId);
			addToCartBtn.data('id', productId);

			$(".productline-options .possible-options .option").removeClass("option--selected");
			$(this).addClass("option--selected");

			toggleLoadingAnimation("product__gallery");
			getProducOptiontInformation(optionId, function (product) {
				if (product.update == true) {
					if (window.jstransobj.isFullView) {
						desktopOptionChange(optionId, product, productId);
					} else {
						mobileOptionChange(optionId, product, productId);
					}
				}
			});

			var optionName = $(this).data("optionName");

			if(optionName) {
				$(".productline-options [data-update-url]").each(function (_, option) {
					var url = new URL(window.location.origin + $(option).attr("href"));
					var params = url.searchParams;
					params.set("preferred_color", optionName.toLowerCase());
					$(option).attr("href", url.pathname + "?" + params.toString());
				});
			}
		});
	}

	function mobileOptionChange(optionId, product, productId) {
		$("[update-main-product-title]").text(product.name);
		$("[update-main-old-price]").text(product.prices.oldPrice);
		$("[update-image-thumb]").attr('src', product.image.thumb);
		var payPrice = product.prices.price;
		if(typeof product.productPrices.siteCoupon !== 'undefined' && product.productPrices.siteCoupon.isActive && product.productPrices.siteCoupon.canBeApplied){
			payPrice = Math.round(product.productPrices.siteCoupon.price * 100) / 100;
			payPrice = payPrice + " " + product.productPrices.siteCoupon.symbol;
		}
		$("[update-main-pay-price]").text(payPrice);

		if (product.prices.discountPercentage == 0) {
			$("update-main-precentage-visibility").hide();
		} else {
			$(".price-row .percent .dprice").text("-" + product.prices.discountPercentage + " %");
			$("update-main-precentage-visibility").show();
		}

		if($('body').data('productTemplateName') == 'default-reborn') {
			$('.stock-info').replaceWith(product.rebornStockInfoRender);
		}

		$.ajax({
			url: window.jstransobj.linkPrefix + "/product/option/gallery/" + productId,
			method: "GET",
			dataType: "JSON",
			success: function (data) {
				$(".product__gallery").replaceWith(data["gallery_html"][0]);
				initiateMobileProductMainGallery();
			},
		});

		$("[data-update-lowest-price-in-past-days]").text(product.prices.lowestSellingPriceInPast);
		if(product.productPrices.lowestSellingPriceInPast.show == "yes") {
			$(".lowest-price-text").show();
		} else {
			$(".lowest-price-text").hide();
		}

		if($('.headerAddToCartBtn').length && product.gallery[0]) {
			$('.headerAddToCartBtn .product-image--thumb').attr('src', product.gallery[0].image);
		}
	}

	function selectCustomQuantityOffer_ifItIsInCart() {
		var cartData = $("#shoppingCart").data("cart");
		var isInCart = false;
		
		if(cartData.products) {
			cartData.products.forEach(function(product) {
				if($('[data-product-id="'+product.productId+'"] [data-tag="'+product.tag+'"]').length) {
					isInCart = true;
				}
				if($('[data-product-id="'+product.productId+'"] [data-tag="'+product.tag+'"]').parents('.offer-wrapper').length) {
					isInCart = true;
				}
			});

			if(isInCart) {
				$('.select-between-offers .offer-wrapper').removeClass('selected');
			}

			cartData.products.forEach(function(product) {
				if(isInCart) {
					$('[data-product-id="'+product.productId+'"] [data-tag="'+product.tag+'"]').addClass('selected');
					$('[data-product-id="'+product.productId+'"] [data-tag="'+product.tag+'"]').parents('.offer-wrapper').addClass('selected');
				}
			});
		}
	}

	function desktopOptionChange(optionId, product, productId) {
		$.ajax({
			url: window.jstransobj.linkPrefix + "/product/option/gallery/" + productId,
			method: "GET",
			dataType: "JSON",
			success: function (data) {
				$(".product__gallery").eq(0).replaceWith(data["gallery_html"][0]);
				$(".product__gallery").eq(1).replaceWith(data["gallery_html"][1]);

				if (typeof $.zoom === "function") {
					$(".main-picture-container").trigger("zoom.destroy");
					$(".main-picture-container").zoom();
				}

				$(".main-picture-container .main-picture").on("load", function () {
					$(".image-loading-icon").css("visibility", "hidden");
					$(".main-picture-container").trigger("zoom.destroy");
					$(".main-picture-container").zoom();
				});
			},
		});

		if(product.gallery[1]) {
			$('.product-image .main-picture.main-picture--backside').css('background-image', 'url(' + product.gallery[1].image + ')');
		}
		if(product.gallery[2]) {		
			$('.product-image .main-picture.main-picture--frontside').css('background-image', 'url(' + product.gallery[2].image + ')');
		}

		$("[update-main-product-title]").text(product.name);
		$("[update-main-old-price]").text(product.prices.oldPrice);
		$(".saved-price .price").text(product.prices.discountPrice);

		var payPrice = product.prices.price;
		if(typeof product.productPrices.siteCoupon !== 'undefined' && product.productPrices.siteCoupon.isActive && product.productPrices.siteCoupon.canBeApplied){
			payPrice = Math.round(product.productPrices.siteCoupon.price * 100) / 100;
			payPrice = payPrice + " " + product.productPrices.siteCoupon.symbol;
		}
		$("[update-main-pay-price]").text(payPrice);

		if (product.prices.discountPercentage == 0) {
			$("[update-main-precentage-visibility]").hide();
		} else {
			$("[update-main-discount-percentage]").text("-" + product.prices.discountPercentage + " %");
			$("[update-main-precentage-visibility]").show();
		}

		if($('.reborn-gallery').length) {
			$('.main-floating-images').animate({'opacity': 0}, 400, function() {
				if(product.gallery[1]) {
					$('.reborn-gallery .main-picture.main-picture--backside').css('background-image', 'url(' + product.gallery[1].image + ')');
					$('.back-in-stock-modal .main-picture.main-picture--backside').css('background-image', 'url(' + product.gallery[1].image + ')');
					$('.reborn-gallery .gallery-with-two img').eq(0).attr('src', product.gallery[1].image);			
				}
				if(product.gallery[2]) {
					$('.reborn-gallery .main-picture.main-picture--frontside').css('background-image', 'url(' + product.gallery[2].image + ')');		
					$('.back-in-stock-modal .main-picture.main-picture--frontside').css('background-image', 'url(' + product.gallery[2].image + ')');		
					$('.reborn-gallery .gallery-with-two img').eq(1).attr('src', product.gallery[2].image);
				}
				
				$('.main-floating-images').animate({'opacity': 1});
			});

			if($('.sticky-add-to-cart').length && product.gallery[0]) {
				$('.sticky-add-to-cart .thumb').attr('src', product.gallery[0].image);
			}

			if($('body').data('productTemplateName') == 'default-reborn') {
				$('.stock-info').replaceWith(product.rebornStockInfoRender);
			}
		}

		$("[data-update-lowest-price-in-past-days]").text(product.prices.lowestSellingPriceInPast);
		if(product.productPrices.lowestSellingPriceInPast.show == "yes") {
			$(".lowest-price-text").show();
		} else {
			$(".lowest-price-text").hide();
		}
	}

	function initiateQuickviewLightbox() {
		[].forEach.call(document.getElementsByClassName("quickview-lightbox"), function (el) {
			el.lightbox = new IframeLightbox(el, {
				onCreated: function () {},
				onLoaded: function () {
					resizeQuickViewIframe();
					window.addEventListener("resize", resizeQuickViewIframe);
				},
				onError: function () {},
				onClosed: function () {
					window.removeEventListener("resize", resizeQuickViewIframe);
				},
				scrolling: false /* default: false */,
				rate: 1 /* default: 500 */,
			});
		});
	}

	function getAdditionalData() {
		var tag = $(".product__quantityDiscount .qd.active").data("tag");
		var priceSource = {};
		var categorized_ics = [];
		

		if ($(".product__quantityDiscount .qd.active").hasClass("easter-egg-wrapper")) {
			priceSource["isTwoPlusOneDiscount"] = true;
		}
		// if (addToCartBtn.data("hasTwoPlusOne") == "yes") {
		// 	priceSource["isTwoPlusOneDiscount"] = true;
		// }

		if(shouldAddCategorizedIcsWithProduct() === true) {
			$('.categorized-cross-sell .cross-product').each(function () {
				if($(this).hasClass('cross-product--checked')) {
					categorized_ics.push(
						{
							'product_cross': {
								'productId': $(this).data('productId'),
								'priceSource': $(this).data('priceSource'),
								'tag': $(this).data('tag'),
								'isProductCrossSell': true,
								'parentId': addToCartBtn.attr('data-id')
							}
						}
					);
				}
			});
		}

		var data = {
			product: {
				priceSource: priceSource,
				tag: tag,
			},
			categorized_ics: categorized_ics
		};

		return data;
	}

	function shouldAddCategorizedIcsWithProduct() {
		var addCategorizedIcs = true;
		var products = getProductsInShoppingCart();

		var productIdsToSearchIn = [];
		$('.selection__options.possible-options .option:not(.option--out-of-stock)').each(function () {
			productIdsToSearchIn.push($(this).data('productId'));
		});

		$.each(products, function () { 
			if(productIdsToSearchIn.indexOf(this.productId) !== -1) {
				addCategorizedIcs = false;
			}
		});

		return addCategorizedIcs;
	}

	function getProductsInShoppingCart() {
		var products = $("#shoppingCart").data("cart") ? $("#shoppingCart").data("cart").products : [];
		if (typeof products == 'object' && typeof products != 'undefined') {
			return products;
		} else {
			return [];
		}
	}

	function getProducOptiontInformation(optionId, callback) {
		toggleLoadingAnimation("price-list");
		if (!window._wcache) {
			window._wcache = {};
		}
		if (!window.jstransobj) {
			window.jstransobj = { linkPrefix: "" };
		}

		if (optionId in window._wcache) {
			toggleLoadingAnimation("price-list");
			callback(window._wcache[optionId]);
			$(".prices").css("opacity", "1");
			$("#addToCart").removeClass("selectbox__addtocart__outOfStock");
			return;
		}

		$.ajax({
			url: window.jstransobj.linkPrefix + "/product/option/" + optionId,
			method: "GET",
			cache: false,
			success: function (response) {
				window._wcache[optionId] = response;
				$(".prices").css("opacity", "1");
				$("#addToCart").removeClass("selectbox__addtocart__outOfStock");
				callback(response);
			},
			error: function (data) {
				if (typeof _errs == "object") {
					_errs.push(new Error(data.responseText));
				}
			},
			complete: function () {
				toggleLoadingAnimation("price-list");
			},
		});
	}

	function crossSellEventMeasurePush() {
		var obj = {};

		var cartIsOpen = typeof bool === "undefined" ? cartTriggerMobile.data("visible") : bool;
		if (cartIsOpen) {
			crossSellOfferWrapper.find(".cart-cross-sell.product").each(function (index, el) {
				if ($(el).data("was-pushed") != "yes") {
					if ($(el).isInViewport(100)) {
						$(el).data("was-pushed", "yes");
						obj = {
							event_category: $("body").data("productId"),
							event_action: "impression_cart_cross",
							event_label: $(el).data("productId"),
						};
						gatgEvent(obj);
					}
				}
			});
		}
	}

	function toggleCartMobile(bool) {
		var cartIsOpen = typeof bool === "undefined" ? cartTriggerMobile.data("visible") : bool;

		if (cartIsOpen) {
			window.location.hash = "";
			//$(window).scrollTop(scrollLocation);
			cartTriggerMobile.data("visible", false);
			cdCartContainer.fadeOut();
			$(".progress-bar-wrapper .bar").width(0);
			cartList.find(".deleted").remove();
			$("#sticky-navigation").show();
			checkProductListScrollHeight();
			$("html, body").removeClass("prevent-body-scroll");
			document.documentElement.scrollTop = documentBodyScrollTop;
			document.body.scrollTop = documentBodyScrollTop;
			$("#sticky-navigation").removeClass("force-sticky");
			cdCart.addClass("desktop-fade-from-left");
		} else {
			cdCartContainer.show();
			window.location.hash += "0";
			//$(window).scrollTop(scrollLocation);
			cartTriggerMobile.data("visible", true);
			adaptRowHeight();
			$(".progress-bar-wrapper .bar").width($(".progress-bar-wrapper .bar").data("value") + "%");
			//$('#sticky-navigation').hide();
			// $("#sticky-navigation").sticky({topSpacing:0});
			if ($("#sticky-navigation-sticky-wrapper").hasClass("is-sticky")) {
				$("#sticky-navigation").addClass("force-sticky");
			}

			documentBodyScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			$("html, body").addClass("prevent-body-scroll");
			document.documentElement.scrollTop = documentBodyScrollTop;
			document.body.scrollTop = documentBodyScrollTop;

			checkProductListScrollHeight();
			updateBodyElements();
			adaptRowHeight();
			if (typeof closeHeaderQuantitySelector == "function") {
				closeHeaderQuantitySelector();
			}
			updateGoToCheckoutButtonPosition();

			if (window.jstransobj.coupon_listing_animation_run != "yes") {
				if (runCouponRegisterEvents && $.trim(crossSellOfferWrapper.html()) != "" && typeof window.siteCoupon !== "undefined") {
					window.siteCoupon.registerEvents();
					runCouponRegisterEvents = false;
				}
			}
			crossSellEventMeasurePush();
			cdCart.removeClass("desktop-fade-from-left");
		}
	}

	function addProductCrossSell($crossSellProduct, callback) {
		var ajaxCall;
		var quantity = $crossSellProduct.find("select :selected").data("count");
		var quantity = typeof quantity === "undefined" ? 1 : quantity;

		var priceSource = $crossSellProduct.data("priceSource");
		var tag = $crossSellProduct.data("tag");
		var data = {
			product_cross: {
				isProductCrossSell: true,
				priceSource: priceSource,
				tag: tag,
				parentId: addToCartBtn.attr('data-id')
			},
		};
		var productId = $crossSellProduct.data("productId");
		var url = jstransobj.linkPrefix + "/cart/add/" + productId + "/" + quantity;
		ajaxCall = $.ajax({
			url: url,
			method: "POST",
			cache: false,
			data: data,
			complete: function (response) {
				getFromCart(false);
				sibPush(getCookie("cart"));

				getAddToCartPushObject(productId, quantity);
				if(typeof klaviyoAddToCart === 'function'){
					klaviyoAddToCart(productId);
				}
				
				if (typeof callback == "function") {
					callback();
				}
			},
		});
		return ajaxCall;
	}

	function addCrossSellFromQuickview(data, callback) {
		$(".iframe-lightbox .backdrop").trigger("click");

		var quantity = data.quantity;
		var productId = data.productId;

		toggleLoadingAnimation("atc" + productId, [], "white");
		addProduct(productId, quantity, "cross");
	}

	function addProductFromSuperbundleQuickview(data, callback) {
		$(".iframe-lightbox .backdrop").trigger("click");

		var quantity = data.quantity;
		var productId = data.productId;

		addProduct(productId, quantity);
	}

	function removeProductCrossSell($crossSellProduct, callback) {
		var ajaxCall;

		var productId = $crossSellProduct.data("productId");
		var url = window.cart_address + jstransobj.linkPrefix + "/cart/remove/item";
		var data = {
			productId: productId,
			job: "remove_product_cross",
		};

		ajaxCall = $.ajax({
			url: url,
			data: { json: JSON.stringify(data) },
			method: "POST",
			success: function (data) {
				getFromCart(false);
				sibPush(getCookie("cart"));

				var quantitySum = getQuantityForProductWithType(productId, "product_cross");
				getItemRemoveFromCartPushObject(productId, quantitySum);
			},
			complete: function () {
				if (typeof callback == "function") {
					callback();
				}
			},
		});

		return ajaxCall;
	}

	function updateProductCrossSellQuantity($crossSellProduct, callback) {
		var ajaxCall;

		var productId = $crossSellProduct.data("productId");

		var quantity = $crossSellProduct.find("select :selected").data("count");

		var quantitySum = getQuantityForProductWithType(productId, "product_cross");
		if (quantity > quantitySum) {
			getAddToCartPushObject(productId, Math.abs(quantitySum - quantity));
		} else if (quantity < quantitySum) {
			getItemRemoveFromCartPushObject(productId, Math.abs(quantitySum - quantity));
		}

		var data = {
			productId: productId,
			quantity: quantity,
			job: "update_product_cross_quantity",
		};

		ajaxCall = $.ajax({
			url: window.cart_address + jstransobj.linkPrefix + "/cart/update/qty",
			data: { json: JSON.stringify(data) },
			method: "POST",
			success: function (data) {
				getFromCart(false);
				sibPush(getCookie("cart"));
			},
			complete: function () {
				if (typeof callback == "function") {
					callback();
				}
			},
		});

		return ajaxCall;
	}

	function getQuantityForProductWithType(productId, productType) {
		var products = $("#shoppingCart").data("cart") ? $("#shoppingCart").data("cart").products : [];
		var sumQuantity = 0;
		for (x in products) {
			if (typeof productType == "undefined") {
				if (products[x].productId == productId) {
					sumQuantity += products[x].qty + products[x].qtyFree;
				}
			} else {
				if (products[x].productId == productId && products[x].productType == productType) {
					sumQuantity += products[x].qty + products[x].qtyFree;
				}
			}
		}

		return sumQuantity;
	}

	function addProduct(product_id, quantity, type, callback) {
		// tu bomo imeli še pogoj, če gre za opcije! in sicer tako, da nastavimo add-to-cart gumbu pravilen ID in definiramo URL
		var url = jstransobj.linkPrefix + "/cart/add/" + product_id + "/" + quantity;
		var data = {};
		var open;
		var priceSource = "";
		var tag = "";
		if (typeof type !== "undefined") {
			if (type == "cross") {
				if ($("#cs" + product_id).data("priceSource")) {
					priceSource = $("#cs" + product_id).data("priceSource");
				}
				tag = $("#cs" + product_id).data("tag");
				data = {
					cross: {
						isCrossSell: true,
						cross_sell_id: $("#cs" + product_id).data("crosssellId"),
						priceSource: priceSource,
						tag: tag,
					},
				};
				open = false;
			}
			if (type == "category-cross") {
				open = false;
				data = {
					product: {
						tag: $("#cs" + product_id).data("tag"),
					},
				};
			}
		} else {
			/** Data for quantity discount and easter-egg */
			data = getAdditionalData();
		}

		$addToCartRequest = $.ajax({
			url: url,
			method: "POST",
			data: data,
			cache: false,
			success: function (data) {
				if (data === "onePiece") {
					alert(window.jstransobj.onlyOnePieceMask);
					getFromCart(false);
				} else {
					addCustomer();
					getFromCart(open);
				}
				getAddToCartPushObject(product_id, quantity);
				redtrackActions('AddToCart');
			},
			complete: function () {
				$addToCartRequest = null;

				var cartId = getCookie("cart");
				sibPush(cartId);
				if(typeof klaviyoAddToCart === 'function'){
					klaviyoAddToCart(product_id);
				}
				if(open != false) {
					loadCartCrossSell();
				}

				if(typeof callback == "function") {
					callback();
				}
			},
		});

		productId = productId + 1;
	}

	function removeProduct(product) {
		var obj = {
			id: 0,
			qty: 0,
		};

		obj.id = product.data("cartProductId");
		obj.qty = parseInt(product.find("select :selected").val());

		if ($removeRequest != null) {
			$removeRequest.abort();
			$removeRequest = null;
		}

		getItemRemoveFromCartPushObject(product.data("productId"), obj.qty);

		$removeRequest = $.ajax({
			url: jstransobj.linkPrefix + "/cart/remove/item",
			method: "POST",
			cache: false,
			data: obj,
			success: function (data) {
				ajaxQueue.pop();
				if (ajaxQueue.length === 0) {
				}

				getFromCart(false);
				sibPush(getCookie("cart"));
				loadCartCrossSell();
			},
		});

		cartList.find(".deleted").remove();

		var topPosition = product.offset().top - cartBody.children("ul").offset().top,
			productQuantity = Number(product.find(".quantity").find("select").val()),
			productTotPrice = Number(product.find(".price").text().replace("$", "")) * productQuantity;

		var childrenCount = cartList.children().length;
		var childHeight = cartList.children().eq(0)[0].scrollHeight;
		var padding = 32;
		cartList.css("height", childrenCount * childHeight + padding + "px");

		cartList.stop().animate(
			{
				height: (childrenCount - 1) * childHeight + padding + "px",
			},
			function () {
				cartList.height("auto");
			}
		);

		product.css("top", topPosition + "px").addClass("deleted");

		/* Remove coupon gift if exists */
		var cartProductId = product.data("cart-product-id");
		var couponGiftRow = cartList.find('li[data-product-type="coupon_gift"][data-cart-product-id="' + cartProductId + '"]');
		if (couponGiftRow.length > 0) {
			couponGiftRow.remove();
		}

		//update items count + total price
		updateCartTotal(productTotPrice, false);
		updateCartCount(
			false,
			cartList.find(
				'[data-product-type="product"], [data-product-type="product_pbq"], [data-product-type="cross"], [data-product-type="product_cross"], [data-product-type="cross2"], [data-product-type="cross3"]'
			).length - 1
		);
	}

	function changeProductQuantity(cart_product_id, quantity) {
		addToCartBtn.css("color", "rgba(255,255,255,.15)");
		toggleLoadingAnimation("add-to-cart", [], "white");
		addToCartBtn.attr("working", "true");

		var productId = $('[data-cart-product-id="' + cart_product_id + '"]').data("productId");
		var obj = {
			id: parseInt(cart_product_id),
			qty: parseInt(quantity),
		};

		/** Make quantity change push before cart is refreshed. */
		var quantitySum = getQuantityForProductWithType(productId);
		if (quantity > quantitySum) {
			getAddToCartPushObject(productId, Math.abs(quantitySum - quantity));
		} else if (quantity < quantitySum) {
			getItemRemoveFromCartPushObject(productId, Math.abs(quantitySum - quantity));
		}

		$.ajax({
			url: jstransobj.linkPrefix + "/cart/update/qty",
			method: "POST",
			cache: false,
			data: obj,
			success: function (data) {
				if (typeof data.status !== "undefined" && data.status === false) {
					alert(data.message);
				}
				getFromCart(false);
				sibPush(getCookie("cart"));
			},
		});
	}

	function getFromCart(open) {
		refreshElements();

		if (typeof open == "undefined") {
			open = true;
		}

		$addToCartRequest = $.ajax({
			url: jstransobj.linkPrefix + "/cart/get",
			method: "POST",
			cache: false,
			// data: { get_full_array: true },
			success: function (data) {
				$("#shoppingCart").data("cart", data);
				cachedData = data;
				refreshShoppingCart(data);

				if (open) {
					cartTriggerMobile.trigger(touchStartOrClickEvent);
				}

				selectCustomQuantityOffer_ifItIsInCart();
			},
			error: function (data) {
				if (typeof _errs == "object") {
					_errs.push(new Error(data.responseText));
				}
			},
			complete: function () {
				if (addToCartBtn.attr("working") === "true") {
					addToCartBtn.attr("working", "false");
					addToCartBtn.css("color", "rgba(255,255,255,1)");
					if(addToCartBtn.find(".animation__rotate").length) {
						toggleLoadingAnimation("add-to-cart", [], "white");
					}
				}
				if (stickyAddToCartBtn.attr("working") === "true") {
					stickyAddToCartBtn.attr("working", "false");
					stickyAddToCartBtn.css("color", "rgba(255,255,255,1)");
					if(stickyAddToCartBtn.find(".animation__rotate").length) {
						toggleLoadingAnimation("sticky-add-to-cart-btn", [], "white");
					}
				}
				if (addToCartBtnBottom.attr("working") === "true") {
					addToCartBtnBottom.attr("working", "false");
					addToCartBtnBottom.css("color", "rgba(255,255,255,1)");
					if(addToCartBtnBottom.find(".animation__rotate").length) {
						toggleLoadingAnimation("add-to-cart-bottom", [], "white");
					}
				}
				$addToCartRequest = null;
				if ($("#headerAddToCartBtn").find(".animation__rotate").length) {
					toggleLoadingAnimation("headerAddToCartBtn", []);
					$("#headerAddToCartBtn").attr("working", "no");
				}
				if ($("#headerQuantitySelector").find(".animation__rotate").length) {
					toggleLoadingAnimation("headerQuantitySelector", []);
					$("#headerAddToCartBtn").attr("working", "no");
				}
				__disableLoader(".superbundle-atc-wrapper");
				addBundleBtn.parent().removeClass("loading");

				addCustomQuantityOffer.removeClass("loading");
				__disableLoader(".quantity-offer-block .add-to-cart");
			},
		});
	}

	$("#goToCheckout").click(function (event) {
		if(typeof window._icsPopup === "object") {
			window._icsPopup.init(event);
		} else {
			goToCheckout(event);
		}
	});

	function goToCheckout(event) {
		if (typeof window.google_tag_manager != "undefined") {
			if (window._getFinalCartObjectPush != "") {
				event.preventDefault();
			}
			dataLayer.push(window._getFinalCartObjectPush);
		}
		redtrackActions('InitiateCheckout');
	}

	function refreshShoppingCart(data) {
		var cartIsOpen = typeof bool === "undefined" ? cartTriggerMobile.data("visible") : bool;
		gtmServicePrepareFinalCartObject();
		cartList.find("li").remove();
		var firstLoad = cartList.find("li").length == 0 ? true : false;
		var parentProduct = [];

		sumAllWrapper.find(".final-price").text(data.cartSumFinal);

		var hrkTransitionCostRaw = parseFloat(data.costRaw) / window.jstransobj.currencyRatio;
		if(window.jstransobj.getArithmeticOperator == '*') {
			hrkTransitionCostRaw = parseFloat(data.costRaw) * window.jstransobj.hrkTransitionCurrencyRate;
		}
		if(window.jstransobj.locale == "hr") {
			sumAllWrapper.find(".final-price-in-eur").remove();
			sumAllWrapper.find(".final-price").after("<div class='final-price-in-eur'>("+(hrkTransitionCostRaw).toFixed(window.jstransobj.currencyPrecision) + " " + window.jstransobj.hrkTransitionCurrency +")<div>");
		}

		product_data = data.products;

		if(typeof product_data == "undefined") {
			emptyCartOverlay.fadeIn();
			crossSellOfferWrapper.hide();
			cartWrapper.addClass("empty");
		}
		
		hasRebornProduct = false;

		for (var key in product_data) {
			var itemId = product_data[key].id;
			var itemImage = product_data[key].productImage;
			var itemName = product_data[key].productName;
			var itemFullName = product_data[key].productName;
			var itemQty = product_data[key].qty;
			var itemQtyFree = product_data[key].qtyFree;
			var productId = product_data[key].productId;
			var productType = product_data[key].productType;
			var productPrice = product_data[key].productPrice;
			var productOldPrice = product_data[key].productOldPrice;
			var productPriceSum = product_data[key].productPriceSum;
			var productUrl = product_data[key].productUrl;

			if (product_data[key].productName.toLowerCase().indexOf("reborn") !== -1) {
				hasRebornProduct = true;
			}

			if (product_data[key].productPriceBeforeCoupon !== null) {
				productOldPrice = product_data[key].productPriceBeforeCoupon;
			}

			if(product_data[key].parentId != "") {
				parentProduct = data.products.filter(function(element) {
					return element.productId == product_data[key].parentId;
				});
			}

			if(parentProduct.length) {
				itemName += "<span class='small-cat-name'> - " + parentProduct[0].defaultCategoryArray['smallName'] + "</span>";
			}

			//item length and other changes
			var itemTrimlength = 160;
			if(window.innerWidth <= 768) {
				itemTrimlength = 90;
			}
			if (itemName.length > itemTrimlength) {
				itemName = itemName.substring(0, itemTrimlength) + " ...";
			}

			var $product_prototype = cartList.data("prototype");

			$product_prototype = $product_prototype.replace("%id%", "p" + productId);
			$product_prototype = $product_prototype.replace("%product_id%", productId);
			$product_prototype = $product_prototype.replace("%cart_product_id%", itemId);
			$product_prototype = $product_prototype.replace("%product_type%", productType);
			$product_prototype = $product_prototype.replace("%image_source%", itemImage);
			$product_prototype = $product_prototype.replace("%product_name%", itemName);
			$product_prototype = $product_prototype.replace("%new_price%", productPrice);
			$product_prototype = $product_prototype.replace("%old_price%", productOldPrice);
			$product_prototype = $product_prototype.replace("%qty%", itemQty);
			$product_prototype = $product_prototype.replace(/%product_url%/g, productUrl);

			$product_prototype = $($product_prototype);

			if (productPrice === productOldPrice) {
				$product_prototype.find(".prices .old").hide();
			}

			if(typeof product_data[key].productPrices != "undefined") {
				if (
					product_data[key].productPriceBeforeCoupon === null && 
					product_data[key].productPrices.oldPriceReason == "calculated" && 
					product_data[key].productType !== "coupon_gift" &&
					window.jstransobj.locale == "si"
				) {
					$product_prototype.find(".prices .old").hide();
				}
			}

			if (product_data[key].couponType == "fixed_amount") {
				$product_prototype.find(".prices .old").hide();
			}

			// če option ne obstaja (nad 10), ga dodamo
			if ($product_prototype.find("option[value=" + itemQty + "]").length == 0) {
				$product_prototype
					.find("select")
					.append($('<option value="' + itemQty + '">' + itemQty + "</option>"))
					.css("width", "52px");
				$product_prototype.find("option[value=" + itemQty + "]").prop("selected", true);
			} else {
				$product_prototype.find("option[value=" + itemQty + "]").prop("selected", true);
			}

			/* Coupon gift specials */
			if (productType == "coupon_gift") {
				$product_prototype.find(".product-icon.gift").show();
				$product_prototype.find(".delete-item").hide();
				$product_prototype.find("select").html($('<option value="' + itemQty + '">' + itemQty + "</option>"));
			} else {
				if (product_data[key].isPartOfBundle == "yes") {
					$product_prototype.find(".product-icon.part-of-bundle").show();
				}
			}

			if (product_data[key].tag.indexOf("reborn") !== -1) {
				$product_prototype.find("select").html($('<option value="' + itemQty + '">' + itemQty + "</option>"));
			}

			if(window.jstransobj.locale == "hr") {
				var hrkTransitionProductPrice = parseFloat(product_data[key].productPriceRaw) / window.jstransobj.currencyRatio;
				if(window.jstransobj.getArithmeticOperator == '*') {
					hrkTransitionProductPrice = parseFloat(product_data[key].productPriceRaw) * window.jstransobj.hrkTransitionCurrencyRate;
				}
				$product_prototype.find(".product-details-bottom").append("<div class='in-eur'>("+(hrkTransitionProductPrice).toFixed(window.jstransobj.currencyPrecision) + " " + window.jstransobj.hrkTransitionCurrency +")<div>");
			}

			cartList.append($product_prototype);

			/* Clear coupon gifts if exists and free quantity < 1 */
			if (itemQtyFree < 1 && productType != "coupon_gift") {
				var couponGiftRow = cartList.find('li[data-product-type="coupon_gift"][data-cart-product-id="' + itemId + '"]');
				if (couponGiftRow.length > 0) {
					couponGiftRow.remove();
				}
			} else if (itemQty == itemQtyFree) {
				// var productRow = cartList.find('li:not([data-product-type="coupon_gift"])[data-cart-product-id="' + itemId + '"]');
				// if (productRow.length > 0) {
				// 	productRow.remove();
				// }
			}

			parentProduct = [];
		}

		//update number of items
		if (typeof product_data !== "undefined") {
			if (product_data.length > 0) {
				$(".cart__counter").text(data.productsCount).removeClass("hidden");

				if (firstLoad) {
					cartWrapper.removeClass("empty");
					emptyCartOverlay.hide();
					firstLoad = false;
				}
			} else {
				$(".cart__counter").text("").addClass("hidden");
			}
		} else {
			$(".cart__counter").text("").addClass("hidden");
		}

		if (data.couponGiftsAndMessages.giftGroups.length > 0) {
			$(".free-gift-with-coupon").show();
		} else {
			$(".free-gift-with-coupon").hide();
		}

		if(hasRebornProduct) {
			$('.heading-wrapper .satisfaction-guarantee').show();
		} else {
			$('.heading-wrapper .satisfaction-guarantee').hide();
		}

		if (cartIsOpen) {
			checkProductListScrollHeight();
		}
		updateBodyElements();
		adaptRowHeight();
		updateGoToCheckoutButtonPosition();
		initiateQuickviewLightbox();
	}

	function loadCartCrossSell() {
		if(null != cartCrossRequest) {
			cartCrossRequest.abort();
		}

		$("#crossSellOfferWrapper").addClass("loading-overlay");
		$("#crossSellOfferWrapper").append('<div class="loading-overlay__loader"><span></span></div>');
		cartCrossRequest = $.ajax({
			url: jstransobj.linkPrefix + "/cart/get/cross-sell",
			method: "POST",
			success: function (data) {
				/* cross sell products */
				if (data.crossSell.products.length == 0) {
					crossSellOfferWrapper.hide();
				} else {
					crossSellOfferWrapper.show();

					crossSellWrapper.html(data.crossSell.html);
					displayProductRating();

					$("#crossSellOfferWrapper .swiper").each(function(_, el) {
						new Swiper(el, {
							speed: 400,
							spaceBetween: 8,
							direction: 'horizontal',
							pagination: {
								el: '.swiper-pagination'
							},                  
							navigation: {
								nextEl: '.swiper-button-next',
								prevEl: '.swiper-button-prev',
							},
							autoHeight: true,
							observer: true,
							observeParents: true,
							observeSlideChildren: true,
							slidesPerView: window.innerWidth < 768 ? 1.1 : 1.4,
							noSwiping: true,
							noSwipingClass: 'atc-button',
							on: {
								slideChange: function(swiper) {
									if(swiper.isEnd) {
										swiper.$el.removeClass("gradient");
									} else {
										swiper.$el.addClass("gradient");
									}
								}
							}
						});
					});

					crossSellEventMeasurePush();
				}
			},
			complete: function () {
				$("#crossSellOfferWrapper").removeClass("loading-overlay");
			}
		});
	}

	function updateGoToCheckoutButtonPosition() {
		var scrollHeight = $("#shoppingCart header")[0].scrollHeight;
		scrollHeight += $("#shoppingCart #cart-list")[0].scrollHeight;
		scrollHeight += $("#shoppingCart .sum-all-wrapper")[0].scrollHeight;

		if (scrollHeight > $(window).innerHeight() - 200) {
			goToCheckoutButton.addClass("fixed-bottom");
			$("#shoppingCart .wrapper").addClass("fixed-bottom");
		} else {
			goToCheckoutButton.removeClass("fixed-bottom");
			$("#shoppingCart .wrapper").removeClass("fixed-bottom");
		}
	}

	function updateBodyElements() {
		if (cachedData != null) {
			if (cachedData.freePPTProgressBarLength != null) {
				$(".gift-notice").show();
				if (cachedData.freePPTProgressBarLength >= 100) {
					$(".gift-notice .text").html(window.jstransobj.freePPTReached);
					$(".progress-bar-wrapper .bar").data("value", 100);
					$(".progress-bar-wrapper .bar").width($(".progress-bar-wrapper .bar").data("value") + "%");
					$(".free-ppt-progress-bar .progress-bar").data('percentage', $(".progress-bar-wrapper .bar").data("value") + "%");
				} else {
					$(".gift-notice .text").html(window.jstransobj.addXForFreePPT.replace("%value%", cachedData.diffToThreshold));
					$(".progress-bar-wrapper .bar").data("value", cachedData.freePPTProgressBarLength);
					$(".progress-bar-wrapper .bar").width($(".progress-bar-wrapper .bar").data("value") + "%");
					$(".free-ppt-progress-bar .progress-bar").data('percentage', $(".progress-bar-wrapper .bar").data("value") + "%");
				}
			} else {
				$(".gift-notice").hide();
				$("#shipping_truck").hide();
			}

			if(hasRebornProduct) {
				$(".gift-notice").hide();
			}

			if($("body").data("productTemplateName").indexOf("reborn") !== -1) {
				$(".gift-notice").hide();
			}

			if(cachedData.isFreeppt == true) {
				$(".gift-notice").show();
			}
		}
		if(typeof animateFreePostageFooterBar == 'function') {
			animateFreePostageFooterBar($('.free-ppt-progress-bar .progress-bar'));
		}
	}

	function adaptRowHeight() {
		var height = 0;

		$(".cell").each(function (index, element) {
			if ((index + 2) % 2 != 0) {
				$(element).prev().height($(element).outerHeight());
			}
		});
	}

	function highlightOptionsSelector() {
		var optionsSelector = $(".poptions").eq(0).offset().top;
		if ($(".selected_option").length) {
			optionsSelector = $(".selected_option").eq(0).offset().top;
		}
		if ($(".poptions").length > 0) {
			$("body, html").animate({
				scrollTop: optionsSelector - 104,
			});
			$(".poptions").addClass("glow");
			setTimeout(function () {
				$(".poptions").removeClass("glow");
			}, 4000);

			if ($(".selected_option").length) {
				$(".selected_option").addClass("glow");
				setTimeout(function () {
					$(".selected_option").removeClass("glow");
				}, 4000);
			}
		}

		setTimeout(function() {
			if (stickyAddToCartBtn.attr("working") == "true") {
				stickyAddToCartBtn.attr("working", "false");
				stickyAddToCartBtn.css("color", "rgba(255,255,255,1)");
				toggleLoadingAnimation("sticky-add-to-cart-btn", [], "white");
			}
		}, 1000);
	}

	function highlightProductLineOptionsSelector() {
		var optionsSelector = $(".selection__options.possible-options").eq(0);
		$("body, html").animate({
			scrollTop: optionsSelector.offset().top - 104,
		});
		optionsSelector.find('.option').each(function() {
			if(!$(this).hasClass('option--out-of-stock')) {
				$(this).addClass('glow');
			}
		});
		setTimeout(function () {
			optionsSelector.find('.option').removeClass("glow");
		}, 4000);

		setTimeout(function() {
			if (stickyAddToCartBtn.attr("working") == "true") {
				stickyAddToCartBtn.attr("working", "false");
				stickyAddToCartBtn.css("color", "rgba(255,255,255,1)");
				toggleLoadingAnimation("sticky-add-to-cart-btn", [], "white");
			}
		}, 1000);
	}

	function updateCartCount(emptyCart, quantity) {
		if (typeof quantity === "undefined") {
			var actual = cartList.find(
				'[data-product-type="product"], [data-product-type="product_pbq"], [data-product-type="cross"], [data-product-type="product_cross"], [data-product-type="cross2"], [data-product-type="cross3"]'
			).length;
		} else {
			var actual = Number(quantity);
		}

		if (actual == 0) {
			emptyCartOverlay.fadeIn();
			crossSellOfferWrapper.hide();
			cartWrapper.addClass("empty");
			//cartCount.addClass('hidden');
			crossSellWrapper.html("");
		}
	}

	function updateCartTotal(price, bool) {
		bool
			? cartTotal.text((Number(cartTotal.text()) + Number(price)).toFixed(2))
			: cartTotal.text((Number(cartTotal.text()) - Number(price)).toFixed(2));
	}

	function checkProductListScrollHeight() {
		if (cartList[0].scrollHeight > cartList.height()) {
			cdCart.addClass("create-space");
		} else {
			cdCart.removeClass("create-space");
		}
	}

	function checkIfOptionIsSelected() {
		if ($(".poptions").find(":selected").data("block") == "true" || $(".poptions").find(":selected").data("block") == true) {
			alert(window.jstransobj.selectProductOption);
			highlightOptionsSelector();
			return false;
		} else if($('.productline-options').length) {
			if($('.productline-options .possible-options .option--selected').length == 0) {
				alert(window.jstransobj.selectProductOption);
				highlightProductLineOptionsSelector();
				return false;
			}
		}

		return true;
	}

	function redtrackActions(type) {
		var xhr = new XMLHttpRequest();
		xhr.open('GET', jstransobj.linkPrefix + '/redtrack-actions?type=' + type, true);
		xhr.send();
	}

	$(window).resize(function () {
		adaptRowHeight();
	});

	$(".cd-cart .wrapper").scroll(function () {
		crossSellEventMeasurePush();
		displayProductRating();
	});

	this.checkIfOptionIsSelected = checkIfOptionIsSelected;
	this.openShoppingCart = toggleCartMobile;
	this.shouldAddCategorizedIcsWithProduct = shouldAddCategorizedIcsWithProduct;
	
	this.updateProductCrossSellQuantity = updateProductCrossSellQuantity;
	
	this.removeProductCrossSell = removeProductCrossSell;
	
	this.addProductCrossSell = addProductCrossSell;
	this.addProduct = addProduct;
	this.addCrossSellFromQuickview = addCrossSellFromQuickview;
	this.addProductFromSuperbundleQuickview = addProductFromSuperbundleQuickview;
	
	this.getFromCart = getFromCart;
	this.getProductsInShoppingCart = getProductsInShoppingCart;

	initiateQuickviewLightbox();
};

function resizeQuickViewIframe() {
	var iframe = document.querySelector(".iframe-lightbox iframe");
	if (iframe) {
		document.querySelector(".iframe-lightbox .content").style.paddingBottom = 0;
		if (iframe.contentWindow.document.body.scrollHeight < window.innerHeight) {
			document.querySelector(".iframe-lightbox .content").style.height = iframe.contentWindow.document.body.scrollHeight + 5 + "px";
		} else {
			iframe.setAttribute("scrolling", "yes");

			if (window.innerWidth < 768) {
				document.querySelector(".iframe-lightbox .content").style.height = window.innerHeight - 104 + "px";
			} else {
				document.querySelector(".iframe-lightbox .content").style.height = window.innerHeight - 200 + "px";
			}
		}
	}
}

function openShoppingCart() {
	mobileCart.openShoppingCart();
}

function getFromCart() {
	mobileCart.getFromCart(false);
}

// ================== SUBSCRIBE =======================

(function () {
	$("#subscribe-input").focus(function () {
		$(".messenger-wrapper").find("img").show();
	});

	$("#agreement").change(function () {
		if ($(this).is(":checked")) {
			$(this).prev().hide();
		} else {
			$(this).prev().show();
		}
	});

	$("#subscribeButton").on("click", function (e) {
		e.preventDefault();
		var cemail = $("#subscribe-input").val();

		var cdata = {
			Email: cemail,
			Country: window.jstransobj.locale,
			Customer: "no",
			Site: window.location.host,
			Name: "",
		};

		if ($("#agreement").is(":checked")) {
			if (validateEmail(cemail)) {
				$.ajax({
					cache: false,
					url: "https://hook.integromat.com/acvsou5d908kpppx8idi2fbm8gpr5r8f  ",
					method: "POST",
					data: cdata,
					success: function (data) {
						alert(window.jstransobj.subscribeSuccessfull);
					},
				});
			} else {
				setTimeout(function () {
					alert(window.jstransobj.emailFormatError);
				}, 10);
			}
		} else {
			setTimeout(function () {
				alert(window.jstransobj.confirmationIsMandatory);
			}, 10);
		}

		if (validateEmail(cemail)) {
			$.ajax({
				cache: false,
				url: window.jstransobj.linkPrefix + "/customer/refresh",
				method: "POST",
				data: cdata,
			});
		}
	});
})();

(function () {
	$("#accept-cookies").on("click", function (e) {
		e.preventDefault();
		setTimeout(function () {
			consentGrantedAdStorage();
			setWaveCookie("cookies", "1", 365);
			$("#cookie-notice").fadeOut();
		}, 1);
	});
})();

/* ============ subscribe to stock ================ */

$("#stock-subscribe-btn").on("click", function (e) {
	e.preventDefault();
	grecaptcha.execute();
});

function stockSubscribe() {
	var $button = $("#stock-subscribe-btn");
	var $input = $("#stock-subscribe-input");
	var email = $input.val();
	var url = [window.location.protocol, "//", window.location.host, window.location.pathname].join("");
	if (validateEmail(email)) {
		var data = {
			productid: $button.data("productId"),
			productURL: url,
			email: email,
			sku: window.currentItemPush[0].sku,
			site: window.location.hostname,
			activeForPurchase: window.currentItemPush[0].activeForPurchase,
		};
		$.ajax({
			cache: false,
			url: "https://hook.integromat.com/u18ybrt13xm8noqri76y2bwek1mbxjfs",
			method: "GET",
			data: data,
			success: function (data) {
				alert(window.jstransobj.subscribeSuccessfull);
			},
			error: function () {
				grecaptcha.reset();
				alert(window.jstransobj.error);
			},
		});

		if (typeof sendinblue !== "undefined") {
			var properties = {
				no_stock_url: url,
			};
			sendinblue.identify(email, properties);
			sendinblue.track("outofstock", {
				event: {
					data: {
						items: window.currentItemPush,
					},
				},
			});
		}
	} else {
		setTimeout(function () {
			grecaptcha.reset();
			alert(window.jstransobj.emailFormatError);
		}, 200);
	}
}

function outOfStockTriggerHook() {
	$.get(window.jstransobj.linkPrefix + "/identify/device/user-agent" + window.location.search, function (response) {
		$.post(
			window.jstransobj.linkPrefix + "/identify/get-out-of-stock-push",
			{
				userAgent: response.userAgent,
				productId: $("body").data("productId"),
				referer: document.referrer,
				fullUrl: [window.location.protocol, "//", window.location.host, window.location.pathname].join(""),
			},
			function (response) {
				if (response.allowPush) {
					$.post("https://hook.integromat.com/brgxuws70t69wohduis1ekqea5indeun", response.data);
				}
			}
		);
	});

	var obj = {
		event_category: $("body").data("productId"),
		event_action: "impression_out_of_stock",
		event_label: $("body").data("productId"),
	};
	gatgEvent(obj);
}

this._siteCoupon = function () {
	var currencyPrecision = window.jstransobj.currencyPrecision;

	if(window.location.pathname.toLowerCase().indexOf("reborn") !== -1) {
		currencyPrecision = 0;
	}

	/*
	 * Funkcija za animiranje cen in popustov pri aktivaciji site-kupona na listingu
	 */
	function animateSiteCouponDiscountsOnListing() {
		var animationFlagUpdate = true;
		var prices = [];
		var options = {
			useEasing: true,
			useGrouping: true,
			separator: window.jstransobj.currencyThousandSeparator === null ? "," : window.jstransobj.currencyThousandSeparator,
			decimal: window.jstransobj.currencyDecimalSeparator === null ? "." : window.jstransobj.currencyDecimalSeparator,
			suffix: window.jstransobj.currencySymbol === null ? " /" : " " + window.jstransobj.currencySymbol,
		};

		var cartSum = parseFloat($("#cart-list").data("cost"));

		$(".product-prices--price").each(function (index, el) {
			if (String($(this).data("couponPrice")) != "false") {
				prices.push({
					countUp: new CountUp(
						$(this).attr("id"),
						$(this).data("price"),
						$(this).data("couponPrice"),
						currencyPrecision,
						2.5,
						options
					),
					id: "#" + $(this).attr("id"),
					isRun: false,
					minOrdervalue: parseFloat($(this).data("minOrderValue")),
				});
			}
		});

		function animateDiscountFlow(element) {
			var $parent = $(element.id).parents(".product-prices");
			var $oldPriceEl = $parent.find(".product-prices--old-price");
			var $discountEl = $parent.find(".product-prices--discount");
			var $priceEl = $parent.find(".product-prices--price");
			var fadeOutTimeout;
			var fadeInTimeout;

			if ($oldPriceEl.length == 0) {
				$parent.prepend(
					'<span class="product-prices--old-price" style="display: none;">' +
						$priceEl.data("price") +
						" " +
						$priceEl.data("symbol") +
						"</span>"
				);
				$oldPriceEl = $parent.find(".product-prices--old-price");
			}

			$oldPriceEl.animate(
				{
					opacity: "0",
				},
				800
			);

			$parent.parents(".bestseller").find(".bestseller-discount-prices .product-prices--discount").fadeOut(800);
			$discountEl.fadeOut(800, function () {
				clearTimeout(fadeOutTimeout);
				fadeOutTimeout = setTimeout(function () {
					$parent.addClass("siteCoupon");

					/* bestseller discount elements have different position */
					$parent.parents(".bestseller").find(".bestseller-discount-prices .product-prices--discount").fadeIn(800);
					$parent.parents(".bestseller").find(".bestseller-discount-prices").addClass("siteCoupon");

					$discountEl.fadeIn(800);
					$oldPriceEl.show();
					$oldPriceEl.animate(
						{
							opacity: "1",
						},
						800,
						function () {
							clearTimeout(fadeInTimeout);
							fadeInTimeout = setTimeout(function () {
								element.countUp.start();
								if (animationFlagUpdate) {
									animationFlagUpdate = false;
									$.post(jstransobj.linkPrefix + "/coupon/update-animation-flag", {
										flag: "coupon_listing_animation_run",
									});
								}
							}, 500);
						}
					);
				}, 1000);
			});
		}

		function findPricesToAnimate(prices, cartSum) {
			prices.forEach(function (element) {
				if (cartSum < element.minOrderValue || element.minOrderValue != 0) {
					if (element.id.indexOf("crossSellProduct") !== -1 && $("#mobile-cart-trigger").data("visible") == false) {
						return;
					}
					if ($(element.id).parents(".product-prices").hasClass("siteCoupon")) {
						element.countUp.start();
						return;
					}
					if ($(element.id).isInViewport(20) && element.isRun === false && $(element.id).attr("isPriceAnimationDone") != "yes") {
						element.isRun = true;
						animateDiscountFlow(element);
						$(element.id).attr("isPriceAnimationDone", "yes");
					}
				}
			});
		}
		if (window.jstransobj.coupon_listing_animation_run != "yes") {
			findPricesToAnimate(prices, cartSum);

			var listingDiscountTimeout;
			window.addEventListener("scroll", function (e) {
				clearTimeout(listingDiscountTimeout);
				listingDiscountTimeout = setTimeout(findPricesToAnimate.bind(null, prices, cartSum), 200);
			});

			$(".cd-cart .wrapper").scroll(function () {
				clearTimeout(listingDiscountTimeout);
				listingDiscountTimeout = setTimeout(findPricesToAnimate.bind(null, prices, cartSum), 200);
			});
		}
	}

	/* ===================================================================================== */

	function animateSiteCouponDiscountOnProduct() {
		var animationFlagUpdate = true;
		var countdown = [];
		var options = {
			useEasing: true,
			useGrouping: true,
			separator: window.jstransobj.currencyThousandSeparator === null ? "," : window.jstransobj.currencyThousandSeparator,
			decimal: window.jstransobj.currencyDecimalSeparator === null ? "." : window.jstransobj.currencyDecimalSeparator,
			suffix: window.jstransobj.currencySymbol === null ? " /" : " " + window.jstransobj.currencySymbol,
		};

		var $price = $(".pay-price");
		var $savingsValue = $(".saved-price .price");
		var cartSum = $("#shoppingCart").data("cart") ? $("#shoppingCart").data("cart").costRaw : 0;

		if (String($price.data("couponPrice")) != "false") {
			countdown.push({
				countUp: new CountUp(
					$price.attr("id"),
					$price.data("price"),
					$price.data("couponPrice"),
					currencyPrecision,
					2.5,
					options
				),
				id: "#" + $price.attr("id"),
				isRun: false,
				minOrderValue: parseFloat($price.data("minOrderValue")),
				couponType: $price.data("couponType"),
			});
			countdown.push({
				countUp: new CountUp(
					$savingsValue.attr("id"),
					$savingsValue.data("discountSaving"),
					$savingsValue.data("discountCouponSaving"),
					currencyPrecision,
					2.5,
					options
				),
				id: "#" + $savingsValue.attr("id"),
				isRun: false,
			});
		}

		function animatePrice(countdown) {
			var fadeOutTimeout;
			var fadeInTimeout;
			if (countdown.length != 0) {
				if (cartSum < countdown[0].minOrderValue || countdown[0].minOrderValue == 0 || countdown[0].couponType == "percentage") {
					if ($(countdown[0].id).isInViewport(10) && countdown[0].isRun === false) {
						countdown[0].isRun = true;
						var $parent = $("#price-list");
						var $savingsEl = $parent.find(".saved-price");
						var $discountEl = $parent.find(".percent");
						var $priceEl = $(countdown[0].id);

						$discountEl.fadeOut(800, function () {
							clearTimeout(fadeOutTimeout);
							fadeOutTimeout = setTimeout(function () {
								$parent.addClass("siteCoupon");
								$discountEl.fadeIn(800, function () {
									clearTimeout(fadeInTimeout);
									fadeInTimeout = setTimeout(function () {
										countdown[0].countUp.start();
										countdown[1].countUp.start();
										if (animationFlagUpdate) {
											animationFlagUpdate = false;
											$.post(jstransobj.linkPrefix + "/coupon/update-animation-flag", {
												flag: "coupon_product_animation_run",
											});
										}
									}, 500);
								});
							}, 1000);
						});
					}
				}
			}
		}
		animatePrice(countdown);

		var productDiscountTimeout;
		window.addEventListener("scroll", function (e) {
			if (String($price.data("couponPrice")) != "false") {
				if (countdown[0].isRun === false) {
					clearTimeout(productDiscountTimeout);
					productDiscountTimeout = setTimeout(animatePrice.bind(null, countdown), 200);
				}
			}
		});
	}
	if (window.jstransobj.coupon_product_animation_run != "yes") {
		if ($("#price-list").length > 0) {
			animateSiteCouponDiscountOnProduct();
		}
	}

	/* ===================================================================================== */

	/* run site coupon countdown if the markup exists */
	(function () {
		var minutesSpan = document.getElementById("scnMinutes");
		var secondsSpan = document.getElementById("scnSeconds");
		var siteCoupoNotice = document.getElementById("site-coupon-notice");
		var scnProgressBar = document.getElementById("scnProgressBar");
		var activeText = document.getElementById("active-text");
		// var activeText2 = document.getElementById('active-text-2');
		var expiredText = document.getElementById("expired-text");
		var reactivatingText = document.getElementById("reactivating-text");
		var reactivatedText = document.getElementById("reactivated-text");
		var width = 0;
		var animate = false;
		var timerInterval;

		if (siteCoupoNotice) {
			var endTime = siteCoupoNotice.getAttribute("data-time");
			var firstUse = siteCoupoNotice.getAttribute("data-first-use");
			var activateButton = document.getElementById("activate");

			activateButton.addEventListener("click", function (e) {
				reactivateCoupon();
			});

			function reactivateCoupon(firstUse) {
				if (typeof firstUse == "undefined") {
					firstUse = false;
				}

				if (!firstUse) {
					var redirectTo = window.location.pathname;
					if (window.location.search == "") {
						redirectTo += "?coupon=" + siteCoupoNotice.getAttribute("data-coupon");
					} else {
						redirectTo += window.location.search + "&coupon=" + siteCoupoNotice.getAttribute("data-coupon");
					}
					window.location = redirectTo;
					return false;
				}

				expiredText.style.display = "none";
				reactivatingText.style.display = "block";
				scnProgressBar.style.width = "100%";
				setTimeout(function () {
					reactivatingText.style.display = "none";
					reactivatedText.style.display = "block";
					setTimeout(function () {
						if (firstUse) {
							setTimeout(function () {
								activeText.style.display = "block";
								expiredText.style.display = "none";
								reactivatedText.style.display = "none";
								scnProgressBar.classList.remove("delay");
								updateScnTimer();
								timerInterval = setInterval(updateScnTimer, 1000);
							}, 2000);
						}
					}, 200);
				}, 3000);
			}

			function updateScnTimer() {
				var t = getTimeRemaining(endTime);

				if (t.total <= 0) {
					$.ajax({
						url: jstransobj.linkPrefix + "/coupon/add",
						method: "POST",
						cache: false,
						data: { code: "", remove: true },
						success: function (data) {},
					});

					clearInterval(timerInterval);
					if (scnProgressBar.getAttribute("data-animate") === "true") {
						scnProgressBar.style.width = "0%";
					}
					activeText.style.display = "none";
					// activeText2 ? activeText2.style.display = "none" : '';
					expiredText.style.display = "block";
					return;
				}

				if (minutesSpan != null && secondsSpan != null) {
					minutesSpan.innerHTML = t.minutes;
					secondsSpan.innerHTML = ("0" + t.seconds).slice(-2);
				}

				if (scnProgressBar.getAttribute("data-animate") === "true") {
					if (animate) {
						width = (100 * t.total) / (30 * 60 * 1000);
						scnProgressBar.style.width = width.toFixed(2) + "%";
					}
				}
			}

			if (firstUse == "true") {
				reactivateCoupon(firstUse);
				// registerEvents();
				$.post(jstransobj.linkPrefix + "/coupon/update-animation-flag?v=" + Math.random(), { flag: "coupon_first_use" });
			} else {
				scnProgressBar.classList.remove("delay");
				updateScnTimer();
				var timerInterval = setInterval(updateScnTimer, 1000);
				// registerEvents();
			}

			setTimeout(function () {
				animate = true;
			}, 1000);
		}
	})();

	this.registerEvents = function () {
		if (window.jstransobj.coupon_listing_animation_run != "yes") {
			animateSiteCouponDiscountsOnListing();
		}
	};
	this.registerEvents();
};

window.addEventListener("load", function () {
	window.siteCoupon = new _siteCoupon();
});

/* =========== expand text on readmore link on category metedata gizzmo.hu/apple */

function readMoreCategoryDescription(e) {
	e.preventDefault();
	var dots = document.getElementById("dots");
	var moreText = document.getElementById("more");
	var btnText = document.getElementById("moreBtn");

	if (dots.style.display === "none") {
		dots.style.display = "inline";
		btnText.innerHTML = window.jstransobj.readMore;
		moreText.style.display = "none";
	} else {
		dots.style.display = "none";
		btnText.innerHTML = window.jstransobj.showLess;
		moreText.style.display = "inline";
	}
}

if (document.getElementById("moreBtn")) {
	document.getElementById("moreBtn").addEventListener("click", readMoreCategoryDescription);
}

function updateBannerSwiperPages(swiper) {
	$(swiper.$el[0]).find(".pages").show();
	$(swiper.$el[0]).find(".pages .current-page").text(swiper.activeIndex + 1);
	$(swiper.$el[0]).find(".pages .all-pages").text(swiper.slides.length);
	if (swiper.activeIndex + 1 >= 10) {
		$(swiper.$el[0]).find(".pages").addClass("xl");
	} else {
		$(swiper.$el[0]).find(".pages").removeClass("xl");
	}
}

(function () {
	function stopResumeBannerVideo(swiper) {
		var selector = ".index__promo";
		$(selector).each(function() {
			if($(this).find("video")[0]) {
				$(this).find("video")[0].pause();
			}
		});
		setTimeout(function() {
			if($(".swiper-container-banners .swiper-slide-active").find("video")[0]) {
				$(".swiper-container-banners .swiper-slide-active").find("video")[0].play();
			}
		}, 100);
	}

	if ($(".swiper-container-banners").length > 0) {
		setTimeout(function () {
			if (window.jstransobj.isFullView === false) {
				var height = 1;
				$(".index__promo .swiper-slide").each(function (index, element) {
					if ($(element).height() > height) {
						height = $(element).height();
					}
				});

				$(".index__promo .swiper-slide").each(function (index, element) {
					$(element).height(height + "px");
				});
			}
			var swiperOptions = {
				autoplay: {},
				speed: 400,
				touchStartPreventDefault: false,
				pagination: {
					el: ".swiper-pagination",
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				noSwiping: true,
				noSwipingClass: 'cta',
				on: {
					afterInit: function() {
						$(".hide-till-init").removeClass("hide-till-init");
						setTimeout(function() {	
							$(".index__promo__container").height("auto");	
						}, 200);
					},
					slideChange: function(swiper) {
						stopResumeBannerVideo(swiper);
					}
				}
			};

			if (window.jstransobj.isFullView == true) {
				Object.assign(swiperOptions, {
					effect: 'fade',
					fadeEffect: {
						crossFade: true
					},
				});
			}

			var banners = new Swiper(".swiper-container-banners", swiperOptions);
			stopResumeBannerVideo(banners);

			if ($(".index__promo .line .bar").length) {
				$(".index__promo .line .bar").width(100 / banners.slides.length + "%");
				banners.on("progress", function (slider, progress) {
					$(".index__promo .line .bar").css({
						left: (100 / banners.slides.length) * (banners.slides.length - 1) * Math.abs(progress) + "%",
					});
				});
			}

			if ($(".index__promo .pages").length) {
				updateBannerSwiperPages(banners);
				banners.on("slideChange", function () {
					updateBannerSwiperPages(banners);
				});
			}

		}, 200);
	}
})();

$(document).ready(function() {
	$(".promotion-countdown").each(function() {
		initializeClock($(this).attr("id"), parseInt($(this).data("endTime")*1000));
	});
});

/* Funkcija poskrbi, da nastavi overlay nad YT player kadar je video na pavzi (da ne prikazuje related videos) */
(function () {
	$(document).on("lazyloaded", function (e) {
		if (e.target.getAttribute("data-YT") == "true") {
			registerYoutubeVideos();
		}
	});
})();

function registerYoutubeVideos() {
	// Activate only if not already activated
	// Activate on all players

	if (typeof window.onYouTubeIframeAPIReadyCallbacks == "undefined") {
		window.onYouTubeIframeAPIReadyCallbacks = [];
		window.youtubePlayers = [];
	} else {
	}

	var playerWrappers = document.querySelectorAll(".hytPlayerWrap");

	Array.prototype.forEach.call(playerWrappers, function (playerWrap) {
		var playerFrame = playerWrap.querySelector("iframe");

		if (playerFrame.getAttribute("registered") == null) {
			if (!$(playerFrame).hasClass("lazyload")) {
				if (playerFrame.getAttribute("src") == null) {
					playerFrame.setAttribute("src", playerFrame.getAttribute("data-src"));
				}

				if (!window.hideYTActivated) {
					var tag = document.createElement("script");
					tag.src = "https://www.youtube.com/iframe_api";
					var firstScriptTag = document.getElementsByTagName("script")[0];
					firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
				}

				var onPlayerStateChange = function (event) {
					if (event.data == YT.PlayerState.ENDED) {
						playerWrap.classList.add("ended");
					} else if (event.data == YT.PlayerState.PAUSED) {
						playerWrap.classList.add("paused");
					} else if (event.data == YT.PlayerState.PLAYING) {
						playerWrap.classList.remove("ended");
						playerWrap.classList.remove("paused");
					}
				};

				var player;
				onYouTubeIframeAPIReadyCallbacks.push({
					executed: false,
					run: function () {
						player = new YT.Player(playerFrame, {
							events: {
								onStateChange: onPlayerStateChange,
							},
						});
						window.youtubePlayers.push(player);
					},
				});

				if (playerFrame.getAttribute("registered") == null) {
					playerWrap.addEventListener("click", function () {
						var playerState = player.getPlayerState();
						if (playerState == YT.PlayerState.ENDED) {
							player.seekTo(0);
						} else if (playerState == YT.PlayerState.PAUSED) {
							player.playVideo();
						}
					});
				}

				if (playerFrame.getAttribute("registered") == null) {
					playerFrame.setAttribute("registered", true);
				}

				if (window.hideYTActivated) {
					Array.prototype.forEach.call(onYouTubeIframeAPIReadyCallbacks, function (callback) {
						if (!callback.executed) {
							setTimeout(function () {
								callback.run();
								callback.executed = true;
							}, 100);
						}
					});
				}
			}
		}
	});

	window.onYouTubeIframeAPIReady = function () {
		Array.prototype.forEach.call(onYouTubeIframeAPIReadyCallbacks, function (callback) {
			if (!callback.executed) {
				setTimeout(function () {
					callback.run();
					callback.executed = true;
				}, 100);
			}
		});
	};

	window.hideYTActivated = true;
}

if (document.getElementById("dragable-element")) {
	dragElement(document.getElementById("dragable-element"));
}

if (document.getElementById("slideToUnlock")) {
	if (window.jstransobj.isFullView) {
		document.getElementById("slideToUnlock").addEventListener("mousedown", function (e) {
			var elmnt = document.getElementById("dragable-element");
			var left = elmnt.offsetLeft;
			$("#dragable-element").removeClass("user-hint");
			elmnt.style.left = left + "px";

			$("#dragable-element").addClass("unlocked");
			$("#slideToUnlock .wrapper").addClass("unlocked");
			$("#dragable-element")
				.stop()
				.animate(
					{
						left: $("#slideToUnlock .wrapper").width() - 44 + "px",
					},
					function () {
						$("#dragable-element").addClass("glow");
						$("#slideToUnlock .inner-text.unlock").fadeOut(function () {
							$("#slideToUnlock .inner-text.unlocked").fadeIn(function () {
								if (
									["product", "landing", "bigcat", "midcat", "smallcat"].indexOf(
										document.body.getAttribute("data-page-type")
									) !== -1
								) {
									window.location.href = $("#slideToUnlock").data("refresh");
								} else {
									window.location.href = $("#slideToUnlock").data("url");
								}
							});
						});
					}
				);
		});
	}
}

function dragElement(elmnt) {
	var pos1 = 0,
		pos2 = 0,
		pos3 = 0,
		pos4 = 0,
		wrapperWidth = $("#slideToUnlock .wrapper").width() - 44,
		clientX,
		clientY,
		value;

	elmnt.onmousedown = dragMouseDown;
	elmnt.addEventListener("touchstart", dragMouseDown, false);

	function dragMouseDown(e) {
		// e.touches[0].clientX
		if ("ontouchstart" in window) {
			clientX = e.touches[0].clientX;
			clientY = e.touches[0].clientY;
		} else {
			clientX = e.clientX;
			clientY = e.clientY;
		}

		e = e || window.event;
		e.preventDefault();
		// get the mouse cursor position at startup:
		pos3 = clientX;
		pos4 = clientY;
		// document.onmouseup = closeDragElement;
		// call a function whenever the cursor moves:
		// document.onmousemove = elementDrag;
		// document.onmousedown = removeUserHint;

		document.addEventListener("touchmove", elementDrag, false);
		document.addEventListener("touchend", closeDragElement, false);
		document.addEventListener("touchstart", removeUserHint, false);
	}

	function removeUserHint(e) {
		e = e || window.event;
		e.preventDefault();

		var left = elmnt.offsetLeft;
		$("#dragable-element").removeClass("user-hint");
		elmnt.style.left = left + "px";
	}

	function elementDrag(e) {
		if ("ontouchstart" in window) {
			clientX = e.touches[0].clientX;
			clientY = e.touches[0].clientY;
		} else {
			clientX = e.clientX;
			clientY = e.clientY;
		}

		e = e || window.event;
		e.preventDefault();
		// calculate the new cursor position:
		pos1 = pos3 - clientX;
		pos2 = pos4 - clientY;
		pos3 = clientX;
		pos4 = clientY;
		// set the element's new position:
		// elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
		if (elmnt.offsetLeft - pos1 >= 4 && elmnt.offsetLeft - pos1 < wrapperWidth) {
			elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
			value = elmnt.offsetLeft - pos1;
		}

		if (elmnt.offsetLeft - pos1 > wrapperWidth - 15) {
			$("#dragable-element").addClass("unlocked");
			$("#slideToUnlock .wrapper").addClass("unlocked");
		}
	}

	function closeDragElement() {
		// stop moving when mouse button is released:
		document.onmouseup = null;
		document.onmousemove = null;

		document.removeEventListener("touchmove", elementDrag);
		document.removeEventListener("touchend", closeDragElement);

		if (elmnt.offsetLeft - pos1 < wrapperWidth - 15 && !$("#dragable-element").hasClass("unlocked")) {
			$("#dragable-element")
				.stop()
				.animate(
					{
						left: "4px",
					},
					function () {
						setTimeout(function () {
							$("#dragable-element").addClass("user-hint");
						}, 300);
					}
				);
		} else {
			elmnt.onmousedown = null;
			elmnt.removeEventListener("touchstart", dragMouseDown);
			$("#dragable-element")
				.stop()
				.animate(
					{
						left: wrapperWidth + "px",
					},
					function () {
						$("#dragable-element").addClass("glow");
						$("#slideToUnlock .inner-text.unlock").fadeOut(function () {
							$("#slideToUnlock .inner-text.unlocked").fadeIn(function () {
								if (
									["product", "landing", "bigcat", "midcat", "smallcat"].indexOf(
										document.body.getAttribute("data-page-type")
									) !== -1
								) {
									window.location.href = $("#slideToUnlock").data("refresh");
								} else {
									window.location.href = $("#slideToUnlock").data("url");
								}
							});
						});
					}
				);
		}
	}
}

$(".return-to-product-widget .close-widget").on("click", function (e) {
	var parent = $(this).parents(".return-to-product-widget");
	var products = [];
	var productId = parent.data("productId");

	if (getCookie("_sales_view_show") == "") {
		products.push(productId);
	} else {
		products = JSON.parse(getCookie("_sales_view_products"));
		if (products.indexOf(productId) === -1) {
			products.push(productId);
		}
	}
	setWaveCookie("_sales_view_show", JSON.stringify(products), 1 / 3);
	parent.fadeOut(function () {
		$(".return-to-product-widget").removeClass("widget-1 widget-0");
	});
});

window.addEventListener("DOMContentLoaded", function (event) {
	var widgets = document.querySelectorAll(".return-to-product-widget");
	var delay = 1000;

	[].forEach.call(widgets, function (el) {
		setTimeout(function () {
			el.classList.add("animate__bounceIn");
		}, delay);
		delay += 500;
	});
});

function initiateMobileProductMainGallery() {
	$(".swiper-container-product-gallery").each(function () {
		var swiper = new Swiper(this, {
			speed: 400,
			direction: "horizontal",

			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			slidesPerView: 1,
			centeredSlides: true,
			autoHeight: true,
			observer: true,
			observeParents: true,
			observeSlideChildren: true,
		});

		var $lineBar = $(swiper.$el[0]).find(".line .bar");
		$lineBar.width(100 / swiper.slides.length + "%");
		swiper.on("progress", function (swiper, progress) {
			if (swiper.slides) {
				$lineBar.css({
					left: (100 / swiper.slides.length) * (swiper.slides.length - 1) * Math.abs(progress) + "%",
				});
			}
		});

		swiper.on("slideChange", function (swiper) {
			updateGallerySwiperPages(swiper);
		});

		updateGallerySwiperPages(swiper);
	});
}

function updateGallerySwiperPages(swiper) {
	$(swiper.$el[0])
		.find(".pages .current-page")
		.text(swiper.activeIndex + 1);
	$(swiper.$el[0]).find(".pages .all-pages").text(swiper.slides.length);
	$(swiper.$el[0]).find(".pages").show();

	if (swiper.activeIndex + 1 >= 10) {
		$(swiper.$el[0]).find(".pages").addClass("xl");
	} else {
		$(swiper.$el[0]).find(".pages").removeClass("xl");
	}

	if ($(swiper.$el[0]).find(".swiper-slide").eq(swiper.activeIndex).find(".iframe-wrapper").length) {
		$(swiper.$el[0]).parents(".product__gallery").find(".discount").hide();
		$(swiper.$el[0]).find(".swiper-button-prev").addClass("white");
		$(swiper.$el[0]).find(".swiper-button-next").addClass("white");
	} else {
		$(swiper.$el[0]).parents(".product__gallery").find(".discount").show();
		$(swiper.$el[0]).find(".swiper-button-prev").removeClass("white");
		$(swiper.$el[0]).find(".swiper-button-next").removeClass("white");
	}
}

(function ($) {
	if ($("body").data("pageType") == "product") {
		var productId = $("body").data("productId");
		$.ajax({
			type: "GET",
			url: window.jstransobj.linkPrefix + "/gtm/" + productId + "/get-item-onload-object",
			success: function (response) {
				dataLayer.push(response[0]);
				dataLayer.push(response[1]);
			},
		});
	}
})(jQuery);

window.addEventListener("load", function (e) {
	if (document.getElementById("mobile-cart-trigger")) {
		document.getElementById("mobile-cart-trigger").style.display = "block";
	}
});

(function ($) {
	var json_string = getCookie("_lvp");
	var pageType = $("body").data("pageType");
	var productId = $("body").data("productId");
	var interval = 5;
	var data = null;
	var cookieLength = 7;
	var allowedHistoryLenght = 10;

	function getLvp() {
		var data = {};
		var currentProduct = [];

		if (pageType == "product") {
			json_string = getCookie("_lvp");
			if (json_string != "") {
				data = JSON.parse(json_string);

				if (Object.keys(data).length > allowedHistoryLenght) {
					var sortingArray = [];
					for (var i in data) {
						if (i == productId) {
							currentProduct.push([i, data[i].time]);
						} else {
							sortingArray.push([i, data[i].time]);
						}
					}
					sortingArray = sortingArray.sort(function (a, b) {
						if (a[1] < b[1]) {
							return 1;
						} else {
							return -1;
						}
					});
					data = {};
					for (var i = 0; i < allowedHistoryLenght - 1; i++) {
						if (typeof sortingArray[i] !== "undefined") {
							data[sortingArray[i][0]] = { time: sortingArray[i][1] };
						}
					}
					if (currentProduct.length) {
						data[currentProduct[0][0]] = { time: currentProduct[0][1] };
					}
				}
			}
		}

		return data;
	}

	data = getLvp();
	if (productId && productId != "0") {
		if (!data[productId]) {
			data[productId] = {
				time: 0,
			};
			setWaveCookie("_lvp", JSON.stringify(data), cookieLength);
		}
	}

	if (pageType == "product") {
		setInterval(function () {
			if (!document.hidden) {
				if (productId && productId != "0") {
					data = getLvp();
					if (data[productId]) {
						data[productId]["time"] += interval;
					}
				}
				setWaveCookie("_lvp", JSON.stringify(data), cookieLength);
			}
		}, interval * 1000);
	}
})(jQuery);

window.addEventListener(
	"message",
	function (event) {
		if (typeof event.data == "string") {
			if (event.data.indexOf("dataSource") !== -1 && event.data.indexOf("quickview")) {
				if (JSON.parse(event.data).trigger == "cross") {
					mobileCart.addCrossSellFromQuickview(JSON.parse(event.data));
				}
				if (JSON.parse(event.data).trigger == "ics") {
					$(".iframe-lightbox .backdrop").trigger("click");
					document.querySelector('.product__crossell[data-product-id="' + JSON.parse(event.data).productId + '"]').click();
				}
				if (JSON.parse(event.data).trigger == "superbundle") {
					mobileCart.addProductFromSuperbundleQuickview(JSON.parse(event.data));
				}
			}
			if (event.data.indexOf("resizeQuickViewIframe") !== -1) {
				resizeQuickViewIframe();
			}
		}
	},
	false
);

$(".prevent-default").on("click", function (event) {
	event.preventDefault();
});

$('[data-scroll-to-element]').click(function() {
	var additionalOffset = $(this).data('additionalOffset') == "" || $(this).data('additionalOffset') == undefined ? 0 : $(this).data('additionalOffset');
	var selector = $(this).data('scrollToElement');
	var $element = $("."+selector).eq(0);
	if($element) {
		$('body, html').animate({'scrollTop': $element.offset().top + parseInt(additionalOffset)});
	}
});

(function($) {
	var $elementsToFilter = $('#generated_options_panel a, #vendor_options_panel a');
	var searchString = "";
	var foundElement = true;

	$('#generated_options_container .search_through_panel__input, #vendor_options_container .search_through_panel__input').keyup(function() {
		searchString = $(this).val().trim().split(" ");
		Array.prototype.forEach.call($elementsToFilter, function(el) {

			foundElement = true;
			searchString.forEach(function(text) {
				if($(el).find('.option_name').text().toLowerCase().indexOf(text.toLowerCase()) === -1) {
					foundElement = false;
				}
			});
			if(foundElement === true) {
				$(el).removeClass("hide");
			} else {
				$(el).addClass("hide");
			}
		});
	});
}(jQuery));

(function($) {
	var $elementsToFilter = $('#generated_colors_panel a');
	var searchString = "";
	var foundElement = true;

	$('#generated_colors_container .search_through_panel__input').keyup(function() {
		searchString = $(this).val().trim().split(" ");
		Array.prototype.forEach.call($elementsToFilter, function(el) {

			foundElement = true;
			searchString.forEach(function(text) {
				if($(el).find('.option_name').text().toLowerCase().indexOf(text.toLowerCase()) === -1) {
					foundElement = false;
				}
			});
			if(foundElement === true) {
				$(el).removeClass("hide");
			} else {
				$(el).addClass("hide");
			}
		});
	});
}(jQuery));

function consentGrantedAdStorage() {
	gtag('consent', 'update', {
	'ad_storage': 'granted',
	'ad_user_data': 'granted',
	'ad_personalization': 'granted',
	'analytics_storage': 'granted'
	});
	document.cookie="cookie=1";
};

window.onload = function() {
	if(typeof window.jstransobj.locale != 'undefined' && window.jstransobj.locale != 'hu') {
		setTimeout(consentGrantedAdStorage, 3000);
	}
};

document.addEventListener('DOMContentLoaded', function() {
    

    var elements = document.querySelectorAll('.form-group .ohranjenost');

	var translations;
	if(typeof translations !== 'undefined'){
		var text = translations["quality.explanation"];
		var spanHTML = '<span class="reborn-quality-explanation-2">(' + text + ')</span>';

		
		elements.forEach(function(element) {
			element.insertAdjacentHTML('beforeend', spanHTML);
		});

		var qualityBracketsPanelBackInStock = new slideOutContainer(
			".slide-out-container.reborn-quality-explanation",
			".reborn-quality-explanation-2"
		);
	}
});


leanpayCalculation = document.querySelector('.leanpay-calculation');
if(leanpayCalculation !== null){
	leanpayCalculation.onclick = function(event) {
		event.preventDefault(); // Prevent the default anchor behavior
		openLeanpayModal();
	};
}

if(document.querySelector('.leanpay-close')){
document.querySelector('.leanpay-close').onclick = function() {
	closeLeanpayModal();
};
}

function openLeanpayModal() {
	document.querySelector('.leanpay-modal').style.display = 'block';
	setTimeout(function() {
		document.querySelector('.leanpay-modal-content').classList.add('open');
	}, 10); // Add a small delay to ensure the display property is set
}

function closeLeanpayModal() {
	document.querySelector('.leanpay-modal-content').classList.remove('open');
	setTimeout(function() {
		document.querySelector('.leanpay-modal').style.display = 'none';
	}, 500); // Match this duration with the CSS transition duration
}

if(document.querySelector('.subscribe-to-back-in-stock')){
document.querySelector('.subscribe-to-back-in-stock').onclick = function(event) {
	event.preventDefault(); // Prevent the default anchor behavior
	openModal();
  };
}
  
if(document.querySelector('#virtual-tour')){
	document.querySelector('#virtual-tour').onclick = function(event) {
		event.preventDefault(); // Prevent the default anchor behavior
		openModalVirtualTour();
	};
}

if(document.querySelector('.back-in-stock-modal .close')){
  document.querySelector('.back-in-stock-modal .close').onclick = function() {
	closeModal();
  };
}

if(document.querySelector('.virtual-tour-modal .close')){
	document.querySelector('.virtual-tour-modal .close').onclick = function() {
		closeModalVirtualTour();
	};
}

window.addEventListener('click', function(event) {
  if (event.target.classList.contains('back-in-stock-modal')) {
    closeModal();
  }

  if (event.target.classList.contains('virtual-tour-modal')) {
    closeModalVirtualTour();
  }
});
  
function openModal() {
	document.querySelector('.back-in-stock-modal').style.display = 'block';
	setTimeout(function() {
	  document.querySelector('.back-in-stock-modal .modal-content').classList.add('open');
	}, 10); // Add a small delay to ensure the display property is set
}
  
function closeModal() {
	document.querySelector('.back-in-stock-modal .modal-content').classList.remove('open');
	setTimeout(function() {
	  document.querySelector('.back-in-stock-modal').style.display = 'none';
	}, 500); // Match this duration with the CSS transition duration
}

function openModalVirtualTour() {
	document.querySelector('.virtual-tour-modal').style.display = 'block';
	setTimeout(function() {
	  document.querySelector('.virtual-tour-modal .modal-content').classList.add('open');
	}, 10); // Add a small delay to ensure the display property is set
}

function closeModalVirtualTour() {
	document.querySelector('.virtual-tour-modal .modal-content').classList.remove('open');
	setTimeout(function() {
	  document.querySelector('.virtual-tour-modal').style.display = 'none';
	}, 500); // Match this duration with the CSS transition duration
}

if(document.querySelector('.success-close')){
	document.querySelector('.success-close').onclick = function() {
		closeSuccessModal();
	  };
}

function closeSuccessModal() {
	document.querySelector('.modal-content-success').classList.remove('open');
	setTimeout(function() {
	  document.querySelector('.back-in-stock-modal-success').style.display = 'none';
	}, 500); // Match this duration with the CSS transition duration
  }

function openSuccessModal() {
	document.querySelector('.modal-content-success').classList.add('open');
	setTimeout(function() {
	  document.querySelector('.back-in-stock-modal-success').style.display = 'block';
	}, 500);
}

  //trustpilot
trustpilotElements = document.querySelectorAll('.trustpilot');

for(i = 0; i < trustpilotElements.length; i++){
	trustpilotElements[i].onclick = function(event) {
		event.preventDefault();
		openTrustpilotModal();
	};
}

if(document.querySelector('.trustpilot-reviews-modal .close')){
	document.querySelector('.trustpilot-reviews-modal .close').onclick = function() {
		closeTrustpilotModal();
	};
}

window.onclick = function(event) {
	if (event.target.classList.contains('trustpilot-reviews-modal')) {
		closeTrustpilotModal();
	}
};

function openTrustpilotModal() {
	document.querySelector('.trustpilot-reviews-modal').style.display = 'block';
	setTimeout(function() {
		document.querySelector('.trustpilot-reviews-modal .modal-content').classList.add('open');
	}, 10);
}

function closeTrustpilotModal() {
	document.querySelector('.trustpilot-reviews-modal .modal-content').classList.remove('open');
	setTimeout(function() {
		document.querySelector('.trustpilot-reviews-modal').style.display = 'none';
	}, 500);
}
  



// UTM tracking new
function getQueryParam(param) {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param) || null;
}

function encryptData(data) {
    var stringifiedData = JSON.stringify(data);
    return btoa(stringifiedData);
}

function decryptData(encryptedData) {
    try {
        return JSON.parse(atob(encryptedData));
    } catch (e) {
        console.error('Decryption failed:', e);
        return null;
    }
}

function getRootDomain() {
    var parts = window.location.hostname.split('.');
    if (parts.length > 2) {
        parts.shift();
    }
    return '.' + parts.join('.');
}

function setEncryptedCookie(cookieName, cookieData) {
    var encryptedData = encryptData(cookieData);

    var daysToExpire = 180;
    var date = new Date();
    date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
    var expires = "expires=" + date.toUTCString();
    var domain = "domain=" + getRootDomain();
    var path = "path=/";

    document.cookie = cookieName + "=" + encodeURIComponent(encryptedData) + "; " + expires + "; " + domain + "; " + path;
}

function getDecryptedCookie(cookieName) {
    var allCookies = document.cookie;

    var cookieArray = allCookies.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookie = cookieArray[i].trim();

        if (cookie.indexOf(cookieName + "=") === 0) {
            var encryptedData = cookie.substring(cookieName.length + 1, cookie.length);

            var decodedData = decodeURIComponent(encryptedData);
            return decryptData(decodedData);
        }
    }

    return null;
}
	
function getReferer() {
	var referer = document.referrer;
	var currentDomain = "gizzmo.si";

	if (referer && !referer.includes(currentDomain)) {
		return referer;
	} else {
		return "x";
	}
}
	
function getCookieValue(cookieName) {
    var cookies = document.cookie.split("; ");
    for (var i = 0; i < cookies.length; i++) {
        var cookiePair = cookies[i].split("=");
        if (cookiePair[0] === cookieName) {
            return cookiePair[1];
        }
    }
    return null;
}

function handleUtmTracking() {

    var utmData = {
        utm_source: getQueryParam('utm_source'),
        utm_medium: getQueryParam('utm_medium'),
        utm_campaign: getQueryParam('utm_campaign'),
        utm_content: getQueryParam('utm_content'),
        utm_term: getQueryParam('utm_term'),
        lander: window.location.href
    };
	
	utmData.fbclid = getQueryParam('fbclid') || getCookieValue('_fbc');
	utmData.gclid = getQueryParam('gclid') || getCookieValue('_gcl_au');


    var referralIds = {
        google: "001",
        facebook: "002",
        tiktok: "003",
        email: "004"
    };

    var cookieData = getDecryptedCookie('user-cart-1');
    if (!cookieData) {
        cookieData = { data: [{}] };
    }

    var firstContactData = cookieData.data[0].first_contact || {};

    if (!firstContactData.first_contact_utm_source && !firstContactData.first_contact_referral_id) {
        cookieData.data[0].first_contact = {
            first_contact_referral_id: referralIds[utmData.utm_source] || "unknown",
            first_contact_utm_source: utmData.utm_source,
            first_contact_utm_medium: utmData.utm_medium,
            first_contact_utm_campaign: utmData.utm_campaign,
            first_contact_utm_content: utmData.utm_content,
            first_contact_utm_term: utmData.utm_term,
            first_contact_gclid: utmData.gclid,
            first_contact_fbclid: utmData.fbclid,
            first_contact_lander: utmData.lander
        };
    }

	if(!firstContactData.first_contact_referral_id || utmData.utm_source){
		cookieData.data[0].last_contact = {
			last_contact_referral_id: referralIds[utmData.utm_source] || "unknown",
			last_contact_utm_source: utmData.utm_source,
			last_contact_utm_medium: utmData.utm_medium,
			last_contact_utm_campaign: utmData.utm_campaign,
			last_contact_utm_content: utmData.utm_content,
			last_contact_utm_term: utmData.utm_term,
			last_contact_gclid: utmData.gclid,
			last_contact_fbclid: utmData.fbclid,
			last_contact_lander: utmData.lander
		};
	}

	if (!cookieData.data[0].referer || cookieData.data[0].referer === "x") {
		cookieData.data[0].referer = getReferer();
	}

    setEncryptedCookie('user-cart-1', cookieData);
	
}

handleUtmTracking();